// src/journeyProblems.js

export const PROBLEM_GROUPS = [
  {
    "key": "love_and_relationships",
    "labels": {
      "he": "קשרים וזוגיות",
      "en": "relationships and relationships",
      "es": "relaciones y relaciones"
    }
  },
  {
    "key": "self_worth",
    "labels": {
      "he": "ערך עצמי, אשמה וביקורת עצמית",
      "en": "Self-worth, guilt and self-criticism",
      "es": "Autoestima, culpa y autocrítica"
    }
  },
  {
    "key": "anxiety",
    "labels": {
      "he": "חרדות ופחדים",
      "en": "Anxieties and fears",
      "es": "Ansiedades y miedos"
    }
  },
  {
    "key": "depression_emptiness_meaning",
    "labels": {
      "he": "דיכאון, ריקנות ומשמעות",
      "en": "Depression, emptiness and meaning",
      "es": "Depresión, vacío y significado"
    }
  },
  {
    "key": "loneliness_belonging",
    "labels": {
      "he": "בדידות ושייכות",
      "en": "Loneliness and belonging",
      "es": "Soledad y pertenencia"
    }
  },
  {
    "key": "childhood_parents_past_wounds",
    "labels": {
      "he": "ילדות, הורים ופצעי עבר",
      "en": "Childhood, parents and past wounds",
      "es": "Infancia, padres y heridas del pasado"
    }
  },
  {
    "key": "parenting_children",
    "labels": {
      "he": "הורות וילדים",
      "en": "Parenting and children",
      "es": "Crianza y niños"
    }
  },
  {
    "key": "work_money_career",
    "labels": {
      "he": "עבודה, כסף וקריירה",
      "en": "Work, money and career",
      "es": "Trabajo, dinero y carrera."
    }
  },
  {
    "key": "loss_grief_radical_changes",
    "labels": {
      "he": "אובדן, אבל ושינויים קיצוניים",
      "en": "Loss, grief and radical changes",
      "es": "Pérdida, duelo y cambios radicales"
    }
  },
  {
    "key": "trauma_vulnerability",
    "labels": {
      "he": "טראומה ופגיעות",
      "en": "trauma and vulnerability",
      "es": "trauma y vulnerabilidad"
    }
  },
  {
    "key": "health_body_self_image",
    "labels": {
      "he": "בריאות, גוף ותדמית עצמית",
      "en": "Health, body and self-image",
      "es": "Salud, cuerpo y autoimagen"
    }
  },
  {
    "key": "harmful_habits_light_addictions",
    "labels": {
      "he": "הרגלים מזיקים והתמכרויות קלות–בינוניות",
      "en": "Harmful habits and light-moderate addictions",
      "es": "Hábitos nocivos y adicciones leves a moderadas."
    }
  },
  {
    "key": "spirituality_faith_meaning",
    "labels": {
      "he": "רוחניות, אמונה ומשמעות",
      "en": "Spirituality, faith and meaning",
      "es": "Espiritualidad, fe y significado."
    }
  },
  {
    "key": "inner_identity_self_confusion",
    "labels": {
      "he": "זהות פנימית ובלבול עצמי",
      "en": "Inner identity and self-confusion",
      "es": "Identidad interior y autoconfusión"
    }
  }
];

export const PROBLEM_LIST = [
  {
    "key": "rel_breakup_fresh_pain",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "כאב פרידה טרייה",
      "en": "The pain of a fresh breakup",
      "es": "El dolor de una nueva ruptura"
    },
    "shortDescription": {
      "he": "כאב פרידה טרייה",
      "en": "The pain of a fresh breakup",
      "es": "El dolor de una nueva ruptura"
    },
    "description": {
      "he": "כאב פרידה טרייה",
      "en": "The pain of a fresh breakup",
      "es": "El dolor de una nueva ruptura"
    },
    "defaultDays": 18,
    "defaultJourneyBlueprintId": "rel_breakup_fresh_pain",
    "journeyBlueprintId": "rel_breakup_fresh_pain"
  },
  {
    "key": "rel_breakup_fresh_pain_phase1",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "כאב פרידה טרייה",
      "en": "The pain of a fresh breakup",
      "es": "El dolor de una nueva ruptura"
    },
    "shortDescription": {
      "he": "מסע הייחוס השקט של Phase 1",
      "en": "The quiet Phase 1 reference journey",
      "es": "El viaje de referencia silencioso de la Fase 1"
    },
    "description": {
      "he": "מסע הייחוס השקט של Phase 1",
      "en": "The quiet Phase 1 reference journey",
      "es": "El viaje de referencia silencioso de la Fase 1"
    },
    "defaultDays": 7,
    "defaultJourneyBlueprintId": "rel_breakup_fresh_pain_phase1",
    "journeyBlueprintId": "rel_breakup_fresh_pain_phase1",
    "hidden": true
  },
  {
    "key": "rel_breakup_fresh_pain_reference_18d",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "כאב פרידה טרייה",
      "en": "The pain of a fresh breakup",
      "es": "El dolor de una nueva ruptura"
    },
    "shortDescription": {
      "he": "מסע רפרנס מלא של 18 ימים לשכתוב הקול החדש",
      "en": "Full 18-day reference journey for the new voice rewrite",
      "es": "Viaje de referencia completo de 18 dias para la nueva reescritura"
    },
    "description": {
      "he": "מסע רפרנס מלא של 18 ימים לשכתוב הקול החדש",
      "en": "Full 18-day reference journey for the new voice rewrite",
      "es": "Viaje de referencia completo de 18 dias para la nueva reescritura"
    },
    "defaultDays": 18,
    "defaultJourneyBlueprintId": "rel_breakup_fresh_pain_reference_18d",
    "journeyBlueprintId": "rel_breakup_fresh_pain_reference_18d",
    "hidden": true
  },
  {
    "key": "obsessive_longing",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "געגוע אובססיבי לאקס/ית",
      "en": "Obsessive longing for an ex",
      "es": "Anhelo obsesivo por un ex"
    },
    "shortDescription": {
      "he": "געגוע אובססיבי לאקס/ית",
      "en": "Obsessive longing for an ex",
      "es": "Anhelo obsesivo por un ex"
    },
    "description": {
      "he": "געגוע אובססיבי לאקס/ית",
      "en": "Obsessive longing for an ex",
      "es": "Anhelo obsesivo por un ex"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "obsessive_longing",
    "journeyBlueprintId": "obsessive_longing"
  },
  {
    "key": "jealousy_ex_moves_on",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "קנאה באקס עם בן/בת זוג חדש/ה",
      "en": "Jealousy of an ex with a new partner",
      "es": "Celos de un ex con nueva pareja"
    },
    "shortDescription": {
      "he": "קנאה באקס עם בן/בת זוג חדש/ה",
      "en": "Jealousy of an ex with a new partner",
      "es": "Celos de un ex con nueva pareja"
    },
    "description": {
      "he": "קנאה באקס עם בן/בת זוג חדש/ה",
      "en": "Jealousy of an ex with a new partner",
      "es": "Celos de un ex con nueva pareja"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "jealousy_ex_moves_on",
    "journeyBlueprintId": "jealousy_ex_moves_on"
  },
  {
    "key": "lack_of_closure_after_breakup",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "חוסר סגירה / צורך ב־Closure",
      "en": "Lack of closure / need for closure",
      "es": "Falta de cierre/necesidad de cierre"
    },
    "shortDescription": {
      "he": "חוסר סגירה / צורך ב־Closure",
      "en": "Lack of closure / need for closure",
      "es": "Falta de cierre/necesidad de cierre"
    },
    "description": {
      "he": "חוסר סגירה / צורך ב־Closure",
      "en": "Lack of closure / need for closure",
      "es": "Falta de cierre/necesidad de cierre"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "lack_of_closure_after_breakup",
    "journeyBlueprintId": "lack_of_closure_after_breakup"
  },
  {
    "key": "fear_never_find_love_again",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "פחד “אני לא אמצא שוב אהבה”",
      "en": "Fear \"I won't find love again\"",
      "es": "Miedo \"No volveré a encontrar el amor\""
    },
    "shortDescription": {
      "he": "פחד “אני לא אמצא שוב אהבה”",
      "en": "Fear \"I won't find love again\"",
      "es": "Miedo \"No volveré a encontrar el amor\""
    },
    "description": {
      "he": "פחד “אני לא אמצא שוב אהבה”",
      "en": "Fear \"I won't find love again\"",
      "es": "Miedo \"No volveré a encontrar el amor\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_never_find_love_again",
    "journeyBlueprintId": "fear_never_find_love_again"
  },
  {
    "key": "getting_stuck_on_an_impossible_one_sided_love",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "להיתקע על אהבה בלתי אפשרית / חד־צדדית",
      "en": "Getting stuck on an impossible / one-sided love",
      "es": "Quedarse atrapado en un amor imposible/unilateral"
    },
    "shortDescription": {
      "he": "להיתקע על אהבה בלתי אפשרית / חד־צדדית",
      "en": "Getting stuck on an impossible / one-sided love",
      "es": "Quedarse atrapado en un amor imposible/unilateral"
    },
    "description": {
      "he": "להיתקע על אהבה בלתי אפשרית / חד־צדדית",
      "en": "Getting stuck on an impossible / one-sided love",
      "es": "Quedarse atrapado en un amor imposible/unilateral"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "getting_stuck_on_an_impossible_one_sided_love",
    "journeyBlueprintId": "getting_stuck_on_an_impossible_one_sided_love"
  },
  {
    "key": "repeating_conflicts_in_relationship",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "מריבות חוזרות (אותו סיפור שוב ושוב)",
      "en": "Repeated fights (same story over and over)",
      "es": "Peleas repetidas (la misma historia una y otra vez)"
    },
    "shortDescription": {
      "he": "מריבות חוזרות (אותו סיפור שוב ושוב)",
      "en": "Repeated fights (same story over and over)",
      "es": "Peleas repetidas (la misma historia una y otra vez)"
    },
    "description": {
      "he": "מריבות חוזרות (אותו סיפור שוב ושוב)",
      "en": "Repeated fights (same story over and over)",
      "es": "Peleas repetidas (la misma historia una y otra vez)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "repeating_conflicts_in_relationship",
    "journeyBlueprintId": "repeating_conflicts_in_relationship"
  },
  {
    "key": "fear_leaving_bad_relationship",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "פחד לעזוב קשר לא טוב",
      "en": "Fear of leaving a bad relationship",
      "es": "Miedo a dejar una mala relación."
    },
    "shortDescription": {
      "he": "פחד לעזוב קשר לא טוב",
      "en": "Fear of leaving a bad relationship",
      "es": "Miedo a dejar una mala relación."
    },
    "description": {
      "he": "פחד לעזוב קשר לא טוב",
      "en": "Fear of leaving a bad relationship",
      "es": "Miedo a dejar una mala relación."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_leaving_bad_relationship",
    "journeyBlueprintId": "fear_leaving_bad_relationship"
  },
  {
    "key": "lack_of_trust_in_relationship",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "חוסר אמון (בגידה, שקרים, סודות)",
      "en": "Distrust (betrayal, lies, secrets)",
      "es": "Desconfianza (traición, mentiras, secretos)"
    },
    "shortDescription": {
      "he": "חוסר אמון (בגידה, שקרים, סודות)",
      "en": "Distrust (betrayal, lies, secrets)",
      "es": "Desconfianza (traición, mentiras, secretos)"
    },
    "description": {
      "he": "חוסר אמון (בגידה, שקרים, סודות)",
      "en": "Distrust (betrayal, lies, secrets)",
      "es": "Desconfianza (traición, mentiras, secretos)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "lack_of_trust_in_relationship",
    "journeyBlueprintId": "lack_of_trust_in_relationship"
  },
  {
    "key": "pursuer_distancer_cycle",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "מעגל רודף–נמנע (אחד רודף, אחד בורח)",
      "en": "Chaser-avoidant circle (one chases, one runs away)",
      "es": "Círculo de evitación de cazadores (uno persigue, el otro huye)"
    },
    "shortDescription": {
      "he": "מעגל רודף–נמנע (אחד רודף, אחד בורח)",
      "en": "Chaser-avoidant circle (one chases, one runs away)",
      "es": "Círculo de evitación de cazadores (uno persigue, el otro huye)"
    },
    "description": {
      "he": "מעגל רודף–נמנע (אחד רודף, אחד בורח)",
      "en": "Chaser-avoidant circle (one chases, one runs away)",
      "es": "Círculo de evitación de cazadores (uno persigue, el otro huye)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "pursuer_distancer_cycle",
    "journeyBlueprintId": "pursuer_distancer_cycle"
  },
  {
    "key": "difficulty_expressing_needs_and_boundaries_with_partner",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "קושי לבטא צרכים וגבולות מול בן/בת הזוג",
      "en": "Difficulty expressing needs and boundaries in front of the partner",
      "es": "Dificultad para expresar necesidades y límites frente a la pareja."
    },
    "shortDescription": {
      "he": "קושי לבטא צרכים וגבולות מול בן/בת הזוג",
      "en": "Difficulty expressing needs and boundaries in front of the partner",
      "es": "Dificultad para expresar necesidades y límites frente a la pareja."
    },
    "description": {
      "he": "קושי לבטא צרכים וגבולות מול בן/בת הזוג",
      "en": "Difficulty expressing needs and boundaries in front of the partner",
      "es": "Dificultad para expresar necesidades y límites frente a la pareja."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_expressing_needs_and_boundaries_with_partner",
    "journeyBlueprintId": "difficulty_expressing_needs_and_boundaries_with_partner"
  },
  {
    "key": "conditional_relationship_fear_of_abandonment",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "קשר שכל הזמן “על תנאי” – פחד שינטשו אותי אם אהיה אני",
      "en": "A relationship that is always \"conditional\" - fear that they will abandon me if I am myself",
      "es": "Una relación siempre \"condicional\" - miedo a que me abandonen si soy yo mismo"
    },
    "shortDescription": {
      "he": "קשר שכל הזמן “על תנאי” – פחד שינטשו אותי אם אהיה אני",
      "en": "A relationship that is always \"conditional\" - fear that they will abandon me if I am myself",
      "es": "Una relación siempre \"condicional\" - miedo a que me abandonen si soy yo mismo"
    },
    "description": {
      "he": "קשר שכל הזמן “על תנאי” – פחד שינטשו אותי אם אהיה אני",
      "en": "A relationship that is always \"conditional\" - fear that they will abandon me if I am myself",
      "es": "Una relación siempre \"condicional\" - miedo a que me abandonen si soy yo mismo"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "conditional_relationship_fear_of_abandonment",
    "journeyBlueprintId": "conditional_relationship_fear_of_abandonment"
  },
  {
    "key": "romantic_loneliness",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "“אני לבד הרבה זמן – משהו דפוק בי?”",
      "en": "\"I've been alone for a long time - something wrong with me?\"",
      "es": "\"He estado sola durante mucho tiempo. ¿Me pasa algo?\""
    },
    "shortDescription": {
      "he": "“אני לבד הרבה זמן – משהו דפוק בי?”",
      "en": "\"I've been alone for a long time - something wrong with me?\"",
      "es": "\"He estado sola durante mucho tiempo. ¿Me pasa algo?\""
    },
    "description": {
      "he": "“אני לבד הרבה זמן – משהו דפוק בי?”",
      "en": "\"I've been alone for a long time - something wrong with me?\"",
      "es": "\"He estado sola durante mucho tiempo. ¿Me pasa algo?\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "romantic_loneliness",
    "journeyBlueprintId": "romantic_loneliness"
  },
  {
    "key": "fear_starting_relationship_dating_anxiety",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "פחד להתחיל קשר (דייטים מלחיצים)",
      "en": "Fear of starting a relationship (stressful dating)",
      "es": "Miedo a iniciar una relación (citas estresantes)"
    },
    "shortDescription": {
      "he": "פחד להתחיל קשר (דייטים מלחיצים)",
      "en": "Fear of starting a relationship (stressful dating)",
      "es": "Miedo a iniciar una relación (citas estresantes)"
    },
    "description": {
      "he": "פחד להתחיל קשר (דייטים מלחיצים)",
      "en": "Fear of starting a relationship (stressful dating)",
      "es": "Miedo a iniciar una relación (citas estresantes)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_starting_relationship_dating_anxiety",
    "journeyBlueprintId": "fear_starting_relationship_dating_anxiety"
  },
  {
    "key": "repeated_attraction_to_destructive_partners",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "משיכה חוזרת לבני/ות זוג הרסניים",
      "en": "Recurrent attraction to destructive partners",
      "es": "Atracción recurrente hacia socios destructivos."
    },
    "shortDescription": {
      "he": "משיכה חוזרת לבני/ות זוג הרסניים",
      "en": "Recurrent attraction to destructive partners",
      "es": "Atracción recurrente hacia socios destructivos."
    },
    "description": {
      "he": "משיכה חוזרת לבני/ות זוג הרסניים",
      "en": "Recurrent attraction to destructive partners",
      "es": "Atracción recurrente hacia socios destructivos."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "repeated_attraction_to_destructive_partners",
    "journeyBlueprintId": "repeated_attraction_to_destructive_partners"
  },
  {
    "key": "difficulty_opening_up_on_dates",
    "groupKey": "love_and_relationships",
    "title": {
      "he": "קושי להיפתח בדייטים (להרגיש קר/ה, סגור/ה)",
      "en": "Difficulty opening up on dates (feeling cold, closed)",
      "es": "Dificultad para abrirse en las citas (sentirse frío, cerrado)"
    },
    "shortDescription": {
      "he": "קושי להיפתח בדייטים (להרגיש קר/ה, סגור/ה)",
      "en": "Difficulty opening up on dates (feeling cold, closed)",
      "es": "Dificultad para abrirse en las citas (sentirse frío, cerrado)"
    },
    "description": {
      "he": "קושי להיפתח בדייטים (להרגיש קר/ה, סגור/ה)",
      "en": "Difficulty opening up on dates (feeling cold, closed)",
      "es": "Dificultad para abrirse en las citas (sentirse frío, cerrado)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_opening_up_on_dates",
    "journeyBlueprintId": "difficulty_opening_up_on_dates"
  },
  {
    "key": "i_am_not_enough",
    "groupKey": "self_worth",
    "title": {
      "he": "תחושת “אני לא מספיק טוב/ה”",
      "en": "Feeling \"I'm not good enough\"",
      "es": "Sentir \"no soy lo suficientemente bueno\""
    },
    "shortDescription": {
      "he": "תחושת “אני לא מספיק טוב/ה”",
      "en": "Feeling \"I'm not good enough\"",
      "es": "Sentir \"no soy lo suficientemente bueno\""
    },
    "description": {
      "he": "תחושת “אני לא מספיק טוב/ה”",
      "en": "Feeling \"I'm not good enough\"",
      "es": "Sentir \"no soy lo suficientemente bueno\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "i_am_not_enough",
    "journeyBlueprintId": "i_am_not_enough"
  },
  {
    "key": "constant_comparison_to_others",
    "groupKey": "self_worth",
    "title": {
      "he": "השוואה תמידית לאחרים",
      "en": "Constant comparison to others",
      "es": "Comparación constante con los demás."
    },
    "shortDescription": {
      "he": "השוואה תמידית לאחרים",
      "en": "Constant comparison to others",
      "es": "Comparación constante con los demás."
    },
    "description": {
      "he": "השוואה תמידית לאחרים",
      "en": "Constant comparison to others",
      "es": "Comparación constante con los demás."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "constant_comparison_to_others",
    "journeyBlueprintId": "constant_comparison_to_others"
  },
  {
    "key": "chronic_sense_of_failure",
    "groupKey": "self_worth",
    "title": {
      "he": "תחושת כישלון כרונית",
      "en": "A chronic sense of failure",
      "es": "Una sensación crónica de fracaso."
    },
    "shortDescription": {
      "he": "תחושת כישלון כרונית",
      "en": "A chronic sense of failure",
      "es": "Una sensación crónica de fracaso."
    },
    "description": {
      "he": "תחושת כישלון כרונית",
      "en": "A chronic sense of failure",
      "es": "Una sensación crónica de fracaso."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "chronic_sense_of_failure",
    "journeyBlueprintId": "chronic_sense_of_failure"
  },
  {
    "key": "difficulty_receiving_compliments_achievements",
    "groupKey": "self_worth",
    "title": {
      "he": "קושי לקבל מחמאות / הישגים",
      "en": "Difficulty receiving compliments / achievements",
      "es": "Dificultad para recibir elogios/logros"
    },
    "shortDescription": {
      "he": "קושי לקבל מחמאות / הישגים",
      "en": "Difficulty receiving compliments / achievements",
      "es": "Dificultad para recibir elogios/logros"
    },
    "description": {
      "he": "קושי לקבל מחמאות / הישגים",
      "en": "Difficulty receiving compliments / achievements",
      "es": "Dificultad para recibir elogios/logros"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_receiving_compliments_achievements",
    "journeyBlueprintId": "difficulty_receiving_compliments_achievements"
  },
  {
    "key": "dependence_on_external_approval",
    "groupKey": "self_worth",
    "title": {
      "he": "תלות באישור מבחוץ (“מה יגידו עליי”)",
      "en": "Dependence on approval from outside (\"what will they say about me\")",
      "es": "Dependencia de la aprobación del exterior (\"qué dirán de mí\")"
    },
    "shortDescription": {
      "he": "תלות באישור מבחוץ (“מה יגידו עליי”)",
      "en": "Dependence on approval from outside (\"what will they say about me\")",
      "es": "Dependencia de la aprobación del exterior (\"qué dirán de mí\")"
    },
    "description": {
      "he": "תלות באישור מבחוץ (“מה יגידו עליי”)",
      "en": "Dependence on approval from outside (\"what will they say about me\")",
      "es": "Dependencia de la aprobación del exterior (\"qué dirán de mí\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "dependence_on_external_approval",
    "journeyBlueprintId": "dependence_on_external_approval"
  },
  {
    "key": "cruel_self_judgment",
    "groupKey": "self_worth",
    "title": {
      "he": "שיפוט עצמי אכזרי (איך שוב עשיתי את זה)",
      "en": "Cruel self-judgment (How did I do it again)",
      "es": "Juicio propio cruel (¿Cómo lo hice otra vez?)"
    },
    "shortDescription": {
      "he": "שיפוט עצמי אכזרי (איך שוב עשיתי את זה)",
      "en": "Cruel self-judgment (How did I do it again)",
      "es": "Juicio propio cruel (¿Cómo lo hice otra vez?)"
    },
    "description": {
      "he": "שיפוט עצמי אכזרי (איך שוב עשיתי את זה)",
      "en": "Cruel self-judgment (How did I do it again)",
      "es": "Juicio propio cruel (¿Cómo lo hice otra vez?)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "cruel_self_judgment",
    "journeyBlueprintId": "cruel_self_judgment"
  },
  {
    "key": "harsh_self_criticism",
    "groupKey": "self_worth",
    "title": {
      "he": "ביקורת עצמית אכזרית",
      "en": "Brutal self-criticism",
      "es": "Autocrítica brutal"
    },
    "shortDescription": {
      "he": "ביקורת עצמית אכזרית",
      "en": "Brutal self-criticism",
      "es": "Autocrítica brutal"
    },
    "description": {
      "he": "ביקורת עצמית אכזרית",
      "en": "Brutal self-criticism",
      "es": "Autocrítica brutal"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "harsh_self_criticism",
    "journeyBlueprintId": "harsh_self_criticism"
  },
  {
    "key": "need_to_be_perfect_in_everything",
    "groupKey": "self_worth",
    "title": {
      "he": "צורך להיות מושלם/ת בכל דבר",
      "en": "Need to be perfect in everything",
      "es": "Necesito ser perfecto en todo."
    },
    "shortDescription": {
      "he": "צורך להיות מושלם/ת בכל דבר",
      "en": "Need to be perfect in everything",
      "es": "Necesito ser perfecto en todo."
    },
    "description": {
      "he": "צורך להיות מושלם/ת בכל דבר",
      "en": "Need to be perfect in everything",
      "es": "Necesito ser perfecto en todo."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "need_to_be_perfect_in_everything",
    "journeyBlueprintId": "need_to_be_perfect_in_everything"
  },
  {
    "key": "fear_of_mistakes",
    "groupKey": "self_worth",
    "title": {
      "he": "פחד אדיר מטעויות",
      "en": "Great fear of mistakes",
      "es": "Gran miedo a los errores."
    },
    "shortDescription": {
      "he": "פחד אדיר מטעויות",
      "en": "Great fear of mistakes",
      "es": "Gran miedo a los errores."
    },
    "description": {
      "he": "פחד אדיר מטעויות",
      "en": "Great fear of mistakes",
      "es": "Gran miedo a los errores."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_mistakes",
    "journeyBlueprintId": "fear_of_mistakes"
  },
  {
    "key": "perfectionism_fear_of_mistakes_procrastination",
    "groupKey": "self_worth",
    "title": {
      "he": "דחיינות מרוב פרפקציוניזם (“אם לא יהיה מושלם – לא מתחיל”)",
      "en": "Procrastination due to too much perfectionism (\"If it's not perfect - it won't start\")",
      "es": "Procrastinación debido a demasiado perfeccionismo (\"Si no es perfecto, no arranca\")"
    },
    "shortDescription": {
      "he": "דחיינות מרוב פרפקציוניזם (“אם לא יהיה מושלם – לא מתחיל”)",
      "en": "Procrastination due to too much perfectionism (\"If it's not perfect - it won't start\")",
      "es": "Procrastinación debido a demasiado perfeccionismo (\"Si no es perfecto, no arranca\")"
    },
    "description": {
      "he": "דחיינות מרוב פרפקציוניזם (“אם לא יהיה מושלם – לא מתחיל”)",
      "en": "Procrastination due to too much perfectionism (\"If it's not perfect - it won't start\")",
      "es": "Procrastinación debido a demasiado perfeccionismo (\"Si no es perfecto, no arranca\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "perfectionism_fear_of_mistakes_procrastination",
    "journeyBlueprintId": "perfectionism_fear_of_mistakes_procrastination"
  },
  {
    "key": "low_self_esteem",
    "groupKey": "self_worth",
    "title": {
      "he": "ערך עצמי נמוך",
      "en": "Low self-esteem",
      "es": "Baja autoestima"
    },
    "shortDescription": {
      "he": "ערך עצמי נמוך",
      "en": "Low self-esteem",
      "es": "Baja autoestima"
    },
    "description": {
      "he": "ערך עצמי נמוך",
      "en": "Low self-esteem",
      "es": "Baja autoestima"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "low_self_esteem",
    "journeyBlueprintId": "low_self_esteem"
  },
  {
    "key": "chronic_feeling_of_failure",
    "groupKey": "self_worth",
    "title": {
      "he": "תחושת כישלון כרונית",
      "en": "Chronic feeling of failure",
      "es": "Sensación crónica de fracaso"
    },
    "shortDescription": {
      "he": "תחושת כישלון כרונית",
      "en": "Chronic feeling of failure",
      "es": "Sensación crónica de fracaso"
    },
    "description": {
      "he": "תחושת כישלון כרונית",
      "en": "Chronic feeling of failure",
      "es": "Sensación crónica de fracaso"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "chronic_feeling_of_failure",
    "journeyBlueprintId": "chronic_feeling_of_failure"
  },
  {
    "key": "anxiety_vigilance",
    "groupKey": "anxiety",
    "title": {
      "he": "תחושת דריכות תמידית / “אסון עוד רגע מגיע”",
      "en": "A constant feeling of alertness / \"Disaster is coming in a moment\"",
      "es": "Una sensación constante de alerta / \"El desastre llegará en un momento\""
    },
    "shortDescription": {
      "he": "תחושת דריכות תמידית / “אסון עוד רגע מגיע”",
      "en": "A constant feeling of alertness / \"Disaster is coming in a moment\"",
      "es": "Una sensación constante de alerta / \"El desastre llegará en un momento\""
    },
    "description": {
      "he": "תחושת דריכות תמידית / “אסון עוד רגע מגיע”",
      "en": "A constant feeling of alertness / \"Disaster is coming in a moment\"",
      "es": "Una sensación constante de alerta / \"El desastre llegará en un momento\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "anxiety_vigilance",
    "journeyBlueprintId": "anxiety_vigilance"
  },
  {
    "key": "anxiety_general",
    "groupKey": "anxiety",
    "title": {
      "he": "דאגנות יתר בכל נושא",
      "en": "Excessive concern in any subject",
      "es": "Preocupación excesiva en cualquier tema."
    },
    "shortDescription": {
      "he": "דאגנות יתר בכל נושא",
      "en": "Excessive concern in any subject",
      "es": "Preocupación excesiva en cualquier tema."
    },
    "description": {
      "he": "דאגנות יתר בכל נושא",
      "en": "Excessive concern in any subject",
      "es": "Preocupación excesiva en cualquier tema."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "anxiety_general",
    "journeyBlueprintId": "anxiety_general"
  },
  {
    "key": "catastrophic_thoughts",
    "groupKey": "anxiety",
    "title": {
      "he": "מחשבות קטסטרופליות (תסריטים של הכי גרוע)",
      "en": "Catastrophic thoughts (worst-case scenarios)",
      "es": "Pensamientos catastróficos (peores escenarios)"
    },
    "shortDescription": {
      "he": "מחשבות קטסטרופליות (תסריטים של הכי גרוע)",
      "en": "Catastrophic thoughts (worst-case scenarios)",
      "es": "Pensamientos catastróficos (peores escenarios)"
    },
    "description": {
      "he": "מחשבות קטסטרופליות (תסריטים של הכי גרוע)",
      "en": "Catastrophic thoughts (worst-case scenarios)",
      "es": "Pensamientos catastróficos (peores escenarios)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "catastrophic_thoughts",
    "journeyBlueprintId": "catastrophic_thoughts"
  },
  {
    "key": "fear_meeting_people_social_events",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד ממפגש עם אנשים / אירועים חברתיים",
      "en": "Fear of meeting people / social events",
      "es": "Miedo a conocer gente/eventos sociales"
    },
    "shortDescription": {
      "he": "פחד ממפגש עם אנשים / אירועים חברתיים",
      "en": "Fear of meeting people / social events",
      "es": "Miedo a conocer gente/eventos sociales"
    },
    "description": {
      "he": "פחד ממפגש עם אנשים / אירועים חברתיים",
      "en": "Fear of meeting people / social events",
      "es": "Miedo a conocer gente/eventos sociales"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_meeting_people_social_events",
    "journeyBlueprintId": "fear_meeting_people_social_events"
  },
  {
    "key": "shame_speaking_audience_work_meetings",
    "groupKey": "anxiety",
    "title": {
      "he": "בושה לדבר מול קהל / ישיבות עבודה",
      "en": "Shame to speak in front of an audience / work meetings",
      "es": "Vergüenza hablar frente a una audiencia/reuniones de trabajo"
    },
    "shortDescription": {
      "he": "בושה לדבר מול קהל / ישיבות עבודה",
      "en": "Shame to speak in front of an audience / work meetings",
      "es": "Vergüenza hablar frente a una audiencia/reuniones de trabajo"
    },
    "description": {
      "he": "בושה לדבר מול קהל / ישיבות עבודה",
      "en": "Shame to speak in front of an audience / work meetings",
      "es": "Vergüenza hablar frente a una audiencia/reuniones de trabajo"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "shame_speaking_audience_work_meetings",
    "journeyBlueprintId": "shame_speaking_audience_work_meetings"
  },
  {
    "key": "feeling_strange_not_belong",
    "groupKey": "anxiety",
    "title": {
      "he": "תחושת “אני מוזר/ה, לא שייך/ת”",
      "en": "Feeling \"I'm strange, I don't belong\"",
      "es": "Sentir \"soy extraño, no pertenezco\""
    },
    "shortDescription": {
      "he": "תחושת “אני מוזר/ה, לא שייך/ת”",
      "en": "Feeling \"I'm strange, I don't belong\"",
      "es": "Sentir \"soy extraño, no pertenezco\""
    },
    "description": {
      "he": "תחושת “אני מוזר/ה, לא שייך/ת”",
      "en": "Feeling \"I'm strange, I don't belong\"",
      "es": "Sentir \"soy extraño, no pertenezco\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "feeling_strange_not_belong",
    "journeyBlueprintId": "feeling_strange_not_belong"
  },
  {
    "key": "replay_after_meeting",
    "groupKey": "anxiety",
    "title": {
      "he": "replay בראש אחרי פגישה – “למה אמרתי ככה…”",
      "en": "replay in my head after a meeting - \"Why did I say that...\"",
      "es": "repetición en mi cabeza después de una reunión: \"¿Por qué dije eso...\""
    },
    "shortDescription": {
      "he": "replay בראש אחרי פגישה – “למה אמרתי ככה…”",
      "en": "replay in my head after a meeting - \"Why did I say that...\"",
      "es": "repetición en mi cabeza después de una reunión: \"¿Por qué dije eso...\""
    },
    "description": {
      "he": "replay בראש אחרי פגישה – “למה אמרתי ככה…”",
      "en": "replay in my head after a meeting - \"Why did I say that...\"",
      "es": "repetición en mi cabeza después de una reunión: \"¿Por qué dije eso...\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "replay_after_meeting",
    "journeyBlueprintId": "replay_after_meeting"
  },
  {
    "key": "anxiety_panic_attacks",
    "groupKey": "anxiety",
    "title": {
      "he": "התקפי חרדה חוזרים (דופק, קוצר נשימה)",
      "en": "Recurrent anxiety attacks (palpitations, shortness of breath)",
      "es": "Ataques de ansiedad recurrentes (palpitaciones, dificultad para respirar)"
    },
    "shortDescription": {
      "he": "התקפי חרדה חוזרים (דופק, קוצר נשימה)",
      "en": "Recurrent anxiety attacks (palpitations, shortness of breath)",
      "es": "Ataques de ansiedad recurrentes (palpitaciones, dificultad para respirar)"
    },
    "description": {
      "he": "התקפי חרדה חוזרים (דופק, קוצר נשימה)",
      "en": "Recurrent anxiety attacks (palpitations, shortness of breath)",
      "es": "Ataques de ansiedad recurrentes (palpitaciones, dificultad para respirar)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "anxiety_panic_attacks",
    "journeyBlueprintId": "anxiety_panic_attacks"
  },
  {
    "key": "fear_leaving_safe_places",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד לצאת ממקומות בטוחים (“מה אם יקרה התקף בחוץ”)",
      "en": "Fear of leaving safe places (\"What if a seizure happens outside\")",
      "es": "Miedo a abandonar lugares seguros (\"¿Qué pasa si ocurre una convulsión afuera?\")"
    },
    "shortDescription": {
      "he": "פחד לצאת ממקומות בטוחים (“מה אם יקרה התקף בחוץ”)",
      "en": "Fear of leaving safe places (\"What if a seizure happens outside\")",
      "es": "Miedo a abandonar lugares seguros (\"¿Qué pasa si ocurre una convulsión afuera?\")"
    },
    "description": {
      "he": "פחד לצאת ממקומות בטוחים (“מה אם יקרה התקף בחוץ”)",
      "en": "Fear of leaving safe places (\"What if a seizure happens outside\")",
      "es": "Miedo a abandonar lugares seguros (\"¿Qué pasa si ocurre una convulsión afuera?\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_leaving_safe_places",
    "journeyBlueprintId": "fear_leaving_safe_places"
  },
  {
    "key": "fear_of_rejection",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד מדחייה",
      "en": "Fear of rejection",
      "es": "Miedo al rechazo"
    },
    "shortDescription": {
      "he": "פחד מדחייה",
      "en": "Fear of rejection",
      "es": "Miedo al rechazo"
    },
    "description": {
      "he": "פחד מדחייה",
      "en": "Fear of rejection",
      "es": "Miedo al rechazo"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_rejection",
    "journeyBlueprintId": "fear_of_rejection"
  },
  {
    "key": "fear_of_failure",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד מכישלון",
      "en": "fear of failure",
      "es": "miedo al fracaso"
    },
    "shortDescription": {
      "he": "פחד מכישלון",
      "en": "fear of failure",
      "es": "miedo al fracaso"
    },
    "description": {
      "he": "פחד מכישלון",
      "en": "fear of failure",
      "es": "miedo al fracaso"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_failure",
    "journeyBlueprintId": "fear_of_failure"
  },
  {
    "key": "fear_of_success",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד מהצלחה",
      "en": "fear of success",
      "es": "miedo al éxito"
    },
    "shortDescription": {
      "he": "פחד מהצלחה",
      "en": "fear of success",
      "es": "miedo al éxito"
    },
    "description": {
      "he": "פחד מהצלחה",
      "en": "fear of success",
      "es": "miedo al éxito"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_success",
    "journeyBlueprintId": "fear_of_success"
  },
  {
    "key": "fear_of_being_alone_in_old_age",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד מלהישאר לבד בזקנה",
      "en": "Fear of being alone in old age",
      "es": "Miedo a estar solo en la vejez"
    },
    "shortDescription": {
      "he": "פחד מלהישאר לבד בזקנה",
      "en": "Fear of being alone in old age",
      "es": "Miedo a estar solo en la vejez"
    },
    "description": {
      "he": "פחד מלהישאר לבד בזקנה",
      "en": "Fear of being alone in old age",
      "es": "Miedo a estar solo en la vejez"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_being_alone_in_old_age",
    "journeyBlueprintId": "fear_of_being_alone_in_old_age"
  },
  {
    "key": "fear_of_illness_death",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד מחולי / מוות",
      "en": "Fear of illness / death",
      "es": "Miedo a la enfermedad/muerte"
    },
    "shortDescription": {
      "he": "פחד מחולי / מוות",
      "en": "Fear of illness / death",
      "es": "Miedo a la enfermedad/muerte"
    },
    "description": {
      "he": "פחד מחולי / מוות",
      "en": "Fear of illness / death",
      "es": "Miedo a la enfermedad/muerte"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_illness_death",
    "journeyBlueprintId": "fear_of_illness_death"
  },
  {
    "key": "anxiety_fear_of_flying",
    "groupKey": "anxiety",
    "title": {
      "he": "פחד מטיסות",
      "en": "Fear of flying",
      "es": "Miedo a volar"
    },
    "shortDescription": {
      "he": "פחד מטיסות",
      "en": "Fear of flying",
      "es": "Miedo a volar"
    },
    "description": {
      "he": "פחד מטיסות",
      "en": "Fear of flying",
      "es": "Miedo a volar"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "anxiety_fear_of_flying",
    "journeyBlueprintId": "anxiety_fear_of_flying"
  },
  {
    "key": "anxiety_claustrophobia",
    "groupKey": "anxiety",
    "title": {
      "he": "קלסטרופוביה / פחד ממקומות סגורים",
      "en": "Claustrophobia / fear of enclosed spaces",
      "es": "Claustrofobia / miedo a espacios cerrados"
    },
    "shortDescription": {
      "he": "קלסטרופוביה / פחד ממקומות סגורים",
      "en": "Claustrophobia / fear of enclosed spaces",
      "es": "Claustrofobia / miedo a espacios cerrados"
    },
    "description": {
      "he": "קלסטרופוביה / פחד ממקומות סגורים",
      "en": "Claustrophobia / fear of enclosed spaces",
      "es": "Claustrofobia / miedo a espacios cerrados"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "anxiety_claustrophobia",
    "journeyBlueprintId": "anxiety_claustrophobia"
  },
  {
    "key": "overthinking_chronic_worry",
    "groupKey": "anxiety",
    "title": {
      "he": "אובר-ת׳ינקינג ודאגנות כרונית",
      "en": "Overthinking and chronic worry",
      "es": "Sobrepensar y preocupación crónica"
    },
    "shortDescription": {
      "he": "אובר-ת׳ינקינג ודאגנות כרונית",
      "en": "Overthinking and chronic worry",
      "es": "Sobrepensar y preocupación crónica"
    },
    "description": {
      "he": "אובר-ת׳ינקינג ודאגנות כרונית",
      "en": "Overthinking and chronic worry",
      "es": "Sobrepensar y preocupación crónica"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "overthinking_chronic_worry",
    "journeyBlueprintId": "overthinking_chronic_worry"
  },
  {
    "key": "feeling_of_inner_emptiness_i_have_no_energy_for_anything",
    "groupKey": "depression_emptiness_meaning",
    "title": {
      "he": "תחושת ריק פנימי (“אין לי אנרגיה לכלום”)",
      "en": "Feeling of inner emptiness (\"I have no energy for anything\")",
      "es": "Sensación de vacío interior (\"No tengo energía para nada\")"
    },
    "shortDescription": {
      "he": "תחושת ריק פנימי (“אין לי אנרגיה לכלום”)",
      "en": "Feeling of inner emptiness (\"I have no energy for anything\")",
      "es": "Sensación de vacío interior (\"No tengo energía para nada\")"
    },
    "description": {
      "he": "תחושת ריק פנימי (“אין לי אנרגיה לכלום”)",
      "en": "Feeling of inner emptiness (\"I have no energy for anything\")",
      "es": "Sensación de vacío interior (\"No tengo energía para nada\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "feeling_of_inner_emptiness_i_have_no_energy_for_anything",
    "journeyBlueprintId": "feeling_of_inner_emptiness_i_have_no_energy_for_anything"
  },
  {
    "key": "lack_of_desire_lack_of_motivation",
    "groupKey": "depression_emptiness_meaning",
    "title": {
      "he": "חוסר חשק / חוסר מוטיבציה",
      "en": "Lack of desire / lack of motivation",
      "es": "Falta de ganas/falta de motivación"
    },
    "shortDescription": {
      "he": "חוסר חשק / חוסר מוטיבציה",
      "en": "Lack of desire / lack of motivation",
      "es": "Falta de ganas/falta de motivación"
    },
    "description": {
      "he": "חוסר חשק / חוסר מוטיבציה",
      "en": "Lack of desire / lack of motivation",
      "es": "Falta de ganas/falta de motivación"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "lack_of_desire_lack_of_motivation",
    "journeyBlueprintId": "lack_of_desire_lack_of_motivation"
  },
  {
    "key": "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason",
    "groupKey": "depression_emptiness_meaning",
    "title": {
      "he": "קושי לקום בבוקר / להרגיש שיש למה",
      "en": "Difficulty getting up in the morning / feeling that there is a reason",
      "es": "Dificultad para levantarse por la mañana/sentir que hay una razón"
    },
    "shortDescription": {
      "he": "קושי לקום בבוקר / להרגיש שיש למה",
      "en": "Difficulty getting up in the morning / feeling that there is a reason",
      "es": "Dificultad para levantarse por la mañana/sentir que hay una razón"
    },
    "description": {
      "he": "קושי לקום בבוקר / להרגיש שיש למה",
      "en": "Difficulty getting up in the morning / feeling that there is a reason",
      "es": "Dificultad para levantarse por la mañana/sentir que hay una razón"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason",
    "journeyBlueprintId": "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason"
  },
  {
    "key": "the_feeling_of_life_passed_me_by",
    "groupKey": "depression_emptiness_meaning",
    "title": {
      "he": "תחושת “החיים עברו לידי”",
      "en": "The feeling of \"life passed me by\"",
      "es": "La sensación de \"la vida me pasó de largo\""
    },
    "shortDescription": {
      "he": "תחושת “החיים עברו לידי”",
      "en": "The feeling of \"life passed me by\"",
      "es": "La sensación de \"la vida me pasó de largo\""
    },
    "description": {
      "he": "תחושת “החיים עברו לידי”",
      "en": "The feeling of \"life passed me by\"",
      "es": "La sensación de \"la vida me pasó de largo\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "the_feeling_of_life_passed_me_by",
    "journeyBlueprintId": "the_feeling_of_life_passed_me_by"
  },
  {
    "key": "loss_of_sense_of_identity_who_am_i_even_today",
    "groupKey": "depression_emptiness_meaning",
    "title": {
      "he": "אובדן תחושת זהות (“מי אני בכלל היום”)",
      "en": "Loss of sense of identity (\"Who am I even today\")",
      "es": "Pérdida del sentido de identidad (\"¿Quién soy yo hoy?\")"
    },
    "shortDescription": {
      "he": "אובדן תחושת זהות (“מי אני בכלל היום”)",
      "en": "Loss of sense of identity (\"Who am I even today\")",
      "es": "Pérdida del sentido de identidad (\"¿Quién soy yo hoy?\")"
    },
    "description": {
      "he": "אובדן תחושת זהות (“מי אני בכלל היום”)",
      "en": "Loss of sense of identity (\"Who am I even today\")",
      "es": "Pérdida del sentido de identidad (\"¿Quién soy yo hoy?\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "loss_of_sense_of_identity_who_am_i_even_today",
    "journeyBlueprintId": "loss_of_sense_of_identity_who_am_i_even_today"
  },
  {
    "key": "everything_is_fine_on_paper_but_inside_is_empty",
    "groupKey": "depression_emptiness_meaning",
    "title": {
      "he": "“הכל בסדר על הנייר – ובפנים ריק”",
      "en": "\"Everything is fine on paper - but inside is empty\"",
      "es": "\"Todo está bien sobre el papel, pero por dentro está vacío\""
    },
    "shortDescription": {
      "he": "“הכל בסדר על הנייר – ובפנים ריק”",
      "en": "\"Everything is fine on paper - but inside is empty\"",
      "es": "\"Todo está bien sobre el papel, pero por dentro está vacío\""
    },
    "description": {
      "he": "“הכל בסדר על הנייר – ובפנים ריק”",
      "en": "\"Everything is fine on paper - but inside is empty\"",
      "es": "\"Todo está bien sobre el papel, pero por dentro está vacío\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "everything_is_fine_on_paper_but_inside_is_empty",
    "journeyBlueprintId": "everything_is_fine_on_paper_but_inside_is_empty"
  },
  {
    "key": "loneliness_even_when_there_are_people_around",
    "groupKey": "loneliness_belonging",
    "title": {
      "he": "בדידות גם כשיש אנשים מסביב",
      "en": "Loneliness even when there are people around",
      "es": "Soledad incluso cuando hay gente alrededor."
    },
    "shortDescription": {
      "he": "בדידות גם כשיש אנשים מסביב",
      "en": "Loneliness even when there are people around",
      "es": "Soledad incluso cuando hay gente alrededor."
    },
    "description": {
      "he": "בדידות גם כשיש אנשים מסביב",
      "en": "Loneliness even when there are people around",
      "es": "Soledad incluso cuando hay gente alrededor."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "loneliness_even_when_there_are_people_around",
    "journeyBlueprintId": "loneliness_even_when_there_are_people_around"
  },
  {
    "key": "i_have_no_one_who_really_knows_me",
    "groupKey": "loneliness_belonging",
    "title": {
      "he": "“אין לי אף אחד שבאמת מכיר אותי”",
      "en": "\"I have no one who really knows me\"",
      "es": "\"No tengo a nadie que me conozca realmente\""
    },
    "shortDescription": {
      "he": "“אין לי אף אחד שבאמת מכיר אותי”",
      "en": "\"I have no one who really knows me\"",
      "es": "\"No tengo a nadie que me conozca realmente\""
    },
    "description": {
      "he": "“אין לי אף אחד שבאמת מכיר אותי”",
      "en": "\"I have no one who really knows me\"",
      "es": "\"No tengo a nadie que me conozca realmente\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "i_have_no_one_who_really_knows_me",
    "journeyBlueprintId": "i_have_no_one_who_really_knows_me"
  },
  {
    "key": "feeling_disconnected_from_the_family_children",
    "groupKey": "loneliness_belonging",
    "title": {
      "he": "תחושת נתק מהמשפחה / מהילדים",
      "en": "Feeling disconnected from the family / children",
      "es": "Sentirse desconectado de la familia/niños"
    },
    "shortDescription": {
      "he": "תחושת נתק מהמשפחה / מהילדים",
      "en": "Feeling disconnected from the family / children",
      "es": "Sentirse desconectado de la familia/niños"
    },
    "description": {
      "he": "תחושת נתק מהמשפחה / מהילדים",
      "en": "Feeling disconnected from the family / children",
      "es": "Sentirse desconectado de la familia/niños"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "feeling_disconnected_from_the_family_children",
    "journeyBlueprintId": "feeling_disconnected_from_the_family_children"
  },
  {
    "key": "difficulty_forming_deep_friendships",
    "groupKey": "loneliness_belonging",
    "title": {
      "he": "קושי ליצור חברויות עמוקות",
      "en": "Difficulty forming deep friendships",
      "es": "Dificultad para formar amistades profundas."
    },
    "shortDescription": {
      "he": "קושי ליצור חברויות עמוקות",
      "en": "Difficulty forming deep friendships",
      "es": "Dificultad para formar amistades profundas."
    },
    "description": {
      "he": "קושי ליצור חברויות עמוקות",
      "en": "Difficulty forming deep friendships",
      "es": "Dificultad para formar amistades profundas."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_forming_deep_friendships",
    "journeyBlueprintId": "difficulty_forming_deep_friendships"
  },
  {
    "key": "feeling_foreign_in_a_new_country_culture",
    "groupKey": "loneliness_belonging",
    "title": {
      "he": "תחושת זרות במדינה / תרבות חדשה",
      "en": "Feeling foreign in a new country / culture",
      "es": "Sentirse extranjero en un nuevo país/cultura"
    },
    "shortDescription": {
      "he": "תחושת זרות במדינה / תרבות חדשה",
      "en": "Feeling foreign in a new country / culture",
      "es": "Sentirse extranjero en un nuevo país/cultura"
    },
    "description": {
      "he": "תחושת זרות במדינה / תרבות חדשה",
      "en": "Feeling foreign in a new country / culture",
      "es": "Sentirse extranjero en un nuevo país/cultura"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "feeling_foreign_in_a_new_country_culture",
    "journeyBlueprintId": "feeling_foreign_in_a_new_country_culture"
  },
  {
    "key": "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me",
    "groupKey": "loneliness_belonging",
    "title": {
      "he": "“אני תמיד זה שמקשיב לכולם – אבל מי מקשיב לי?”",
      "en": "\"I'm always the one who listens to everyone - but who listens to me?\"",
      "es": "\"Siempre soy yo quien escucha a todos, pero ¿quién me escucha a mí?\""
    },
    "shortDescription": {
      "he": "“אני תמיד זה שמקשיב לכולם – אבל מי מקשיב לי?”",
      "en": "\"I'm always the one who listens to everyone - but who listens to me?\"",
      "es": "\"Siempre soy yo quien escucha a todos, pero ¿quién me escucha a mí?\""
    },
    "description": {
      "he": "“אני תמיד זה שמקשיב לכולם – אבל מי מקשיב לי?”",
      "en": "\"I'm always the one who listens to everyone - but who listens to me?\"",
      "es": "\"Siempre soy yo quien escucha a todos, pero ¿quién me escucha a mí?\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me",
    "journeyBlueprintId": "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me"
  },
  {
    "key": "feeling_of_abandonment_parents_are_emotionally_physically_unavailable",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "תחושת נטישה (הורים לא זמינים רגשית / פיזית)",
      "en": "Feeling of abandonment (parents are emotionally/physically unavailable)",
      "es": "Sentimiento de abandono (los padres no están disponibles emocional o físicamente)"
    },
    "shortDescription": {
      "he": "תחושת נטישה (הורים לא זמינים רגשית / פיזית)",
      "en": "Feeling of abandonment (parents are emotionally/physically unavailable)",
      "es": "Sentimiento de abandono (los padres no están disponibles emocional o físicamente)"
    },
    "description": {
      "he": "תחושת נטישה (הורים לא זמינים רגשית / פיזית)",
      "en": "Feeling of abandonment (parents are emotionally/physically unavailable)",
      "es": "Sentimiento de abandono (los padres no están disponibles emocional o físicamente)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "feeling_of_abandonment_parents_are_emotionally_physically_unavailable",
    "journeyBlueprintId": "feeling_of_abandonment_parents_are_emotionally_physically_unavailable"
  },
  {
    "key": "conditional_love_good_only_if_i_succeed",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "אהבה על תנאי (“טוב רק אם אני מצליח/ה”)",
      "en": "conditional love (\"good only if I succeed\")",
      "es": "amor condicional (\"bueno sólo si tengo éxito\")"
    },
    "shortDescription": {
      "he": "אהבה על תנאי (“טוב רק אם אני מצליח/ה”)",
      "en": "conditional love (\"good only if I succeed\")",
      "es": "amor condicional (\"bueno sólo si tengo éxito\")"
    },
    "description": {
      "he": "אהבה על תנאי (“טוב רק אם אני מצליח/ה”)",
      "en": "conditional love (\"good only if I succeed\")",
      "es": "amor condicional (\"bueno sólo si tengo éxito\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "conditional_love_good_only_if_i_succeed",
    "journeyBlueprintId": "conditional_love_good_only_if_i_succeed"
  },
  {
    "key": "lack_of_protection_childhood_were_not_there_for_me",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "חוסר הגנה / בילדות לא היו שם בשבילי",
      "en": "Lack of protection / childhood were not there for me",
      "es": "Desprotección / la infancia no estuvo ahí para mí"
    },
    "shortDescription": {
      "he": "חוסר הגנה / בילדות לא היו שם בשבילי",
      "en": "Lack of protection / childhood were not there for me",
      "es": "Desprotección / la infancia no estuvo ahí para mí"
    },
    "description": {
      "he": "חוסר הגנה / בילדות לא היו שם בשבילי",
      "en": "Lack of protection / childhood were not there for me",
      "es": "Desprotección / la infancia no estuvo ahí para mí"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "lack_of_protection_childhood_were_not_there_for_me",
    "journeyBlueprintId": "lack_of_protection_childhood_were_not_there_for_me"
  },
  {
    "key": "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "ביקורתיות חריפה של הורה שחיה בתוכי עד היום",
      "en": "Harsh criticism of a parent that lives inside me to this day",
      "es": "Duras críticas a un padre que vive dentro de mí hasta el día de hoy"
    },
    "shortDescription": {
      "he": "ביקורתיות חריפה של הורה שחיה בתוכי עד היום",
      "en": "Harsh criticism of a parent that lives inside me to this day",
      "es": "Duras críticas a un padre que vive dentro de mí hasta el día de hoy"
    },
    "description": {
      "he": "ביקורתיות חריפה של הורה שחיה בתוכי עד היום",
      "en": "Harsh criticism of a parent that lives inside me to this day",
      "es": "Duras críticas a un padre que vive dentro de mí hasta el día de hoy"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day",
    "journeyBlueprintId": "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day"
  },
  {
    "key": "an_inner_child_who_didn_t_feel_wanted_loved",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "ילד פנימי שלא הרגיש רצוי / אהוב",
      "en": "An inner child who didn't feel wanted / loved",
      "es": "Un niño interior que no se sentía querido/amado"
    },
    "shortDescription": {
      "he": "ילד פנימי שלא הרגיש רצוי / אהוב",
      "en": "An inner child who didn't feel wanted / loved",
      "es": "Un niño interior que no se sentía querido/amado"
    },
    "description": {
      "he": "ילד פנימי שלא הרגיש רצוי / אהוב",
      "en": "An inner child who didn't feel wanted / loved",
      "es": "Un niño interior que no se sentía querido/amado"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "an_inner_child_who_didn_t_feel_wanted_loved",
    "journeyBlueprintId": "an_inner_child_who_didn_t_feel_wanted_loved"
  },
  {
    "key": "a_critical_domineering_parent_even_in_adulthood",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "הורה ביקורתי / שתלטן גם בבגרות",
      "en": "A critical / domineering parent even in adulthood",
      "es": "Un padre crítico/dominante incluso en la edad adulta"
    },
    "shortDescription": {
      "he": "הורה ביקורתי / שתלטן גם בבגרות",
      "en": "A critical / domineering parent even in adulthood",
      "es": "Un padre crítico/dominante incluso en la edad adulta"
    },
    "description": {
      "he": "הורה ביקורתי / שתלטן גם בבגרות",
      "en": "A critical / domineering parent even in adulthood",
      "es": "Un padre crítico/dominante incluso en la edad adulta"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "a_critical_domineering_parent_even_in_adulthood",
    "journeyBlueprintId": "a_critical_domineering_parent_even_in_adulthood"
  },
  {
    "key": "the_feeling_of_i_m_still_their_child_they_don_t_see_the_adult_in_me",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "תחושת “אני עדיין הילד שלהם, לא רואים את הבוגר שבי”",
      "en": "The feeling of \"I'm still their child, they don't see the adult in me\"",
      "es": "El sentimiento de \"todavía soy su hijo, no ven al adulto que hay en mí\"."
    },
    "shortDescription": {
      "he": "תחושת “אני עדיין הילד שלהם, לא רואים את הבוגר שבי”",
      "en": "The feeling of \"I'm still their child, they don't see the adult in me\"",
      "es": "El sentimiento de \"todavía soy su hijo, no ven al adulto que hay en mí\"."
    },
    "description": {
      "he": "תחושת “אני עדיין הילד שלהם, לא רואים את הבוגר שבי”",
      "en": "The feeling of \"I'm still their child, they don't see the adult in me\"",
      "es": "El sentimiento de \"todavía soy su hijo, no ven al adulto que hay en mí\"."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "the_feeling_of_i_m_still_their_child_they_don_t_see_the_adult_in_me",
    "journeyBlueprintId": "the_feeling_of_i_m_still_their_child_they_don_t_see_the_adult_in_me"
  },
  {
    "key": "difficulty_forgiving_a_parent_for_the_past",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "קושי לסלוח להורה על העבר",
      "en": "Difficulty forgiving a parent for the past",
      "es": "Dificultad para perdonar a un padre por el pasado"
    },
    "shortDescription": {
      "he": "קושי לסלוח להורה על העבר",
      "en": "Difficulty forgiving a parent for the past",
      "es": "Dificultad para perdonar a un padre por el pasado"
    },
    "description": {
      "he": "קושי לסלוח להורה על העבר",
      "en": "Difficulty forgiving a parent for the past",
      "es": "Dificultad para perdonar a un padre por el pasado"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_forgiving_a_parent_for_the_past",
    "journeyBlueprintId": "difficulty_forgiving_a_parent_for_the_past"
  },
  {
    "key": "a_sick_aging_parent_emotional_burden",
    "groupKey": "childhood_parents_past_wounds",
    "title": {
      "he": "הורה חולה / מזדקן – עומס רגשי",
      "en": "A sick / aging parent - emotional burden",
      "es": "Un padre enfermo o anciano: carga emocional"
    },
    "shortDescription": {
      "he": "הורה חולה / מזדקן – עומס רגשי",
      "en": "A sick / aging parent - emotional burden",
      "es": "Un padre enfermo o anciano: carga emocional"
    },
    "description": {
      "he": "הורה חולה / מזדקן – עומס רגשי",
      "en": "A sick / aging parent - emotional burden",
      "es": "Un padre enfermo o anciano: carga emocional"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "a_sick_aging_parent_emotional_burden",
    "journeyBlueprintId": "a_sick_aging_parent_emotional_burden"
  },
  {
    "key": "feelings_of_guilt_as_a_parent_i_ruined_their_lives",
    "groupKey": "parenting_children",
    "title": {
      "he": "רגשות אשמה כהורה (“הרסתי להם את החיים”)",
      "en": "Feelings of guilt as a parent (\"I ruined their lives\")",
      "es": "Sentimientos de culpa como padre (“les arruiné la vida”)"
    },
    "shortDescription": {
      "he": "רגשות אשמה כהורה (“הרסתי להם את החיים”)",
      "en": "Feelings of guilt as a parent (\"I ruined their lives\")",
      "es": "Sentimientos de culpa como padre (“les arruiné la vida”)"
    },
    "description": {
      "he": "רגשות אשמה כהורה (“הרסתי להם את החיים”)",
      "en": "Feelings of guilt as a parent (\"I ruined their lives\")",
      "es": "Sentimientos de culpa como padre (“les arruiné la vida”)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "feelings_of_guilt_as_a_parent_i_ruined_their_lives",
    "journeyBlueprintId": "feelings_of_guilt_as_a_parent_i_ruined_their_lives"
  },
  {
    "key": "conflicts_with_teenagers",
    "groupKey": "parenting_children",
    "title": {
      "he": "קונפליקטים עם בני נוער",
      "en": "Conflicts with teenagers",
      "es": "Conflictos con los adolescentes"
    },
    "shortDescription": {
      "he": "קונפליקטים עם בני נוער",
      "en": "Conflicts with teenagers",
      "es": "Conflictos con los adolescentes"
    },
    "description": {
      "he": "קונפליקטים עם בני נוער",
      "en": "Conflicts with teenagers",
      "es": "Conflictos con los adolescentes"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "conflicts_with_teenagers",
    "journeyBlueprintId": "conflicts_with_teenagers"
  },
  {
    "key": "difficulty_setting_boundaries_with_the_children",
    "groupKey": "parenting_children",
    "title": {
      "he": "קושי להציב גבולות עם הילדים",
      "en": "Difficulty setting boundaries with the children",
      "es": "Dificultad para establecer límites con los niños."
    },
    "shortDescription": {
      "he": "קושי להציב גבולות עם הילדים",
      "en": "Difficulty setting boundaries with the children",
      "es": "Dificultad para establecer límites con los niños."
    },
    "description": {
      "he": "קושי להציב גבולות עם הילדים",
      "en": "Difficulty setting boundaries with the children",
      "es": "Dificultad para establecer límites con los niños."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_setting_boundaries_with_the_children",
    "journeyBlueprintId": "difficulty_setting_boundaries_with_the_children"
  },
  {
    "key": "single_parent_parenting_after_divorce",
    "groupKey": "parenting_children",
    "title": {
      "he": "הורה יחיד / הורות אחרי גירושין",
      "en": "Single parent / parenting after divorce",
      "es": "Padre soltero/paternidad después del divorcio"
    },
    "shortDescription": {
      "he": "הורה יחיד / הורות אחרי גירושין",
      "en": "Single parent / parenting after divorce",
      "es": "Padre soltero/paternidad después del divorcio"
    },
    "description": {
      "he": "הורה יחיד / הורות אחרי גירושין",
      "en": "Single parent / parenting after divorce",
      "es": "Padre soltero/paternidad después del divorcio"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "single_parent_parenting_after_divorce",
    "journeyBlueprintId": "single_parent_parenting_after_divorce"
  },
  {
    "key": "children_who_live_in_another_country_far_away",
    "groupKey": "parenting_children",
    "title": {
      "he": "ילדים שחיים במדינה אחרת / רחוקים",
      "en": "Children who live in another country / far away",
      "es": "Niños que viven en otro país/lejos"
    },
    "shortDescription": {
      "he": "ילדים שחיים במדינה אחרת / רחוקים",
      "en": "Children who live in another country / far away",
      "es": "Niños que viven en otro país/lejos"
    },
    "description": {
      "he": "ילדים שחיים במדינה אחרת / רחוקים",
      "en": "Children who live in another country / far away",
      "es": "Niños que viven en otro país/lejos"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "children_who_live_in_another_country_far_away",
    "journeyBlueprintId": "children_who_live_in_another_country_far_away"
  },
  {
    "key": "fear_the_children_will_stay_away_from_me_hate_me",
    "groupKey": "parenting_children",
    "title": {
      "he": "פחד “הילדים יתרחקו ממני / ישנאו אותי”",
      "en": "Fear \"the children will stay away from me / hate me\"",
      "es": "Miedo \"los niños se alejarán de mí / me odiarán\""
    },
    "shortDescription": {
      "he": "פחד “הילדים יתרחקו ממני / ישנאו אותי”",
      "en": "Fear \"the children will stay away from me / hate me\"",
      "es": "Miedo \"los niños se alejarán de mí / me odiarán\""
    },
    "description": {
      "he": "פחד “הילדים יתרחקו ממני / ישנאו אותי”",
      "en": "Fear \"the children will stay away from me / hate me\"",
      "es": "Miedo \"los niños se alejarán de mí / me odiarán\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_the_children_will_stay_away_from_me_hate_me",
    "journeyBlueprintId": "fear_the_children_will_stay_away_from_me_hate_me"
  },
  {
    "key": "burnout",
    "groupKey": "work_money_career",
    "title": {
      "he": "שחיקה / Burnout",
      "en": "Burnout",
      "es": "agotamiento"
    },
    "shortDescription": {
      "he": "שחיקה / Burnout",
      "en": "Burnout",
      "es": "agotamiento"
    },
    "description": {
      "he": "שחיקה / Burnout",
      "en": "Burnout",
      "es": "agotamiento"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "burnout",
    "journeyBlueprintId": "burnout"
  },
  {
    "key": "task_load_home_work_imbalance",
    "groupKey": "work_money_career",
    "title": {
      "he": "עומס משימות, חוסר איזון בית–עבודה",
      "en": "Task load, home-work imbalance",
      "es": "Carga de tareas, desequilibrio entre el trabajo y la casa"
    },
    "shortDescription": {
      "he": "עומס משימות, חוסר איזון בית–עבודה",
      "en": "Task load, home-work imbalance",
      "es": "Carga de tareas, desequilibrio entre el trabajo y la casa"
    },
    "description": {
      "he": "עומס משימות, חוסר איזון בית–עבודה",
      "en": "Task load, home-work imbalance",
      "es": "Carga de tareas, desequilibrio entre el trabajo y la casa"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "task_load_home_work_imbalance",
    "journeyBlueprintId": "task_load_home_work_imbalance"
  },
  {
    "key": "fear_of_losing_a_job_livelihood",
    "groupKey": "work_money_career",
    "title": {
      "he": "פחד מאיבוד עבודה / פרנסה",
      "en": "Fear of losing a job / livelihood",
      "es": "Miedo a perder el trabajo o el sustento"
    },
    "shortDescription": {
      "he": "פחד מאיבוד עבודה / פרנסה",
      "en": "Fear of losing a job / livelihood",
      "es": "Miedo a perder el trabajo o el sustento"
    },
    "description": {
      "he": "פחד מאיבוד עבודה / פרנסה",
      "en": "Fear of losing a job / livelihood",
      "es": "Miedo a perder el trabajo o el sustento"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_losing_a_job_livelihood",
    "journeyBlueprintId": "fear_of_losing_a_job_livelihood"
  },
  {
    "key": "conflicts_with_boss_colleagues",
    "groupKey": "work_money_career",
    "title": {
      "he": "קונפליקטים עם בוס / קולגות",
      "en": "Conflicts with boss / colleagues",
      "es": "Conflictos con jefe/compañeros"
    },
    "shortDescription": {
      "he": "קונפליקטים עם בוס / קולגות",
      "en": "Conflicts with boss / colleagues",
      "es": "Conflictos con jefe/compañeros"
    },
    "description": {
      "he": "קונפליקטים עם בוס / קולגות",
      "en": "Conflicts with boss / colleagues",
      "es": "Conflictos con jefe/compañeros"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "conflicts_with_boss_colleagues",
    "journeyBlueprintId": "conflicts_with_boss_colleagues"
  },
  {
    "key": "a_feeling_that_i_am_not_realizing_my_abilities",
    "groupKey": "work_money_career",
    "title": {
      "he": "תחושה שאני לא מממש את היכולות שלי",
      "en": "A feeling that I am not realizing my abilities",
      "es": "Una sensación de que no me estoy dando cuenta de mis habilidades."
    },
    "shortDescription": {
      "he": "תחושה שאני לא מממש את היכולות שלי",
      "en": "A feeling that I am not realizing my abilities",
      "es": "Una sensación de que no me estoy dando cuenta de mis habilidades."
    },
    "description": {
      "he": "תחושה שאני לא מממש את היכולות שלי",
      "en": "A feeling that I am not realizing my abilities",
      "es": "Una sensación de que no me estoy dando cuenta de mis habilidades."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "a_feeling_that_i_am_not_realizing_my_abilities",
    "journeyBlueprintId": "a_feeling_that_i_am_not_realizing_my_abilities"
  },
  {
    "key": "financial_anxiety_debts",
    "groupKey": "work_money_career",
    "title": {
      "he": "חרדה כלכלית / חובות",
      "en": "Financial anxiety / debts",
      "es": "Ansiedad financiera / deudas"
    },
    "shortDescription": {
      "he": "חרדה כלכלית / חובות",
      "en": "Financial anxiety / debts",
      "es": "Ansiedad financiera / deudas"
    },
    "description": {
      "he": "חרדה כלכלית / חובות",
      "en": "Financial anxiety / debts",
      "es": "Ansiedad financiera / deudas"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "financial_anxiety_debts",
    "journeyBlueprintId": "financial_anxiety_debts"
  },
  {
    "key": "fear_of_making_financial_decisions",
    "groupKey": "work_money_career",
    "title": {
      "he": "פחד מקבלת החלטות כלכליות",
      "en": "Fear of making financial decisions",
      "es": "Miedo a tomar decisiones financieras."
    },
    "shortDescription": {
      "he": "פחד מקבלת החלטות כלכליות",
      "en": "Fear of making financial decisions",
      "es": "Miedo a tomar decisiones financieras."
    },
    "description": {
      "he": "פחד מקבלת החלטות כלכליות",
      "en": "Fear of making financial decisions",
      "es": "Miedo a tomar decisiones financieras."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "fear_of_making_financial_decisions",
    "journeyBlueprintId": "fear_of_making_financial_decisions"
  },
  {
    "key": "stress_around_investments_risks",
    "groupKey": "work_money_career",
    "title": {
      "he": "לחץ סביב השקעות / סיכונים",
      "en": "Stress around investments / risks",
      "es": "Estrés en torno a inversiones/riesgos"
    },
    "shortDescription": {
      "he": "לחץ סביב השקעות / סיכונים",
      "en": "Stress around investments / risks",
      "es": "Estrés en torno a inversiones/riesgos"
    },
    "description": {
      "he": "לחץ סביב השקעות / סיכונים",
      "en": "Stress around investments / risks",
      "es": "Estrés en torno a inversiones/riesgos"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "stress_around_investments_risks",
    "journeyBlueprintId": "stress_around_investments_risks"
  },
  {
    "key": "a_sense_of_financial_failure_compared_to_others",
    "groupKey": "work_money_career",
    "title": {
      "he": "תחושת כישלון כלכלי לעומת אחרים",
      "en": "A sense of financial failure compared to others",
      "es": "Una sensación de fracaso financiero en comparación con los demás."
    },
    "shortDescription": {
      "he": "תחושת כישלון כלכלי לעומת אחרים",
      "en": "A sense of financial failure compared to others",
      "es": "Una sensación de fracaso financiero en comparación con los demás."
    },
    "description": {
      "he": "תחושת כישלון כלכלי לעומת אחרים",
      "en": "A sense of financial failure compared to others",
      "es": "Una sensación de fracaso financiero en comparación con los demás."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "a_sense_of_financial_failure_compared_to_others",
    "journeyBlueprintId": "a_sense_of_financial_failure_compared_to_others"
  },
  {
    "key": "loss_of_a_loved_one_death",
    "groupKey": "loss_grief_radical_changes",
    "title": {
      "he": "אובדן אדם קרוב (מוות)",
      "en": "loss of a loved one (death)",
      "es": "pérdida de un ser querido (muerte)"
    },
    "shortDescription": {
      "he": "אובדן אדם קרוב (מוות)",
      "en": "loss of a loved one (death)",
      "es": "pérdida de un ser querido (muerte)"
    },
    "description": {
      "he": "אובדן אדם קרוב (מוות)",
      "en": "loss of a loved one (death)",
      "es": "pérdida de un ser querido (muerte)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "loss_of_a_loved_one_death",
    "journeyBlueprintId": "loss_of_a_loved_one_death"
  },
  {
    "key": "but_about_the_end_of_a_relationship_a_family_that_fell_apart",
    "groupKey": "loss_grief_radical_changes",
    "title": {
      "he": "אבל על סוף קשר / משפחה שהתפרקה",
      "en": "But about the end of a relationship / a family that fell apart",
      "es": "Pero sobre el fin de una relación/una familia que se desmoronó"
    },
    "shortDescription": {
      "he": "אבל על סוף קשר / משפחה שהתפרקה",
      "en": "But about the end of a relationship / a family that fell apart",
      "es": "Pero sobre el fin de una relación/una familia que se desmoronó"
    },
    "description": {
      "he": "אבל על סוף קשר / משפחה שהתפרקה",
      "en": "But about the end of a relationship / a family that fell apart",
      "es": "Pero sobre el fin de una relación/una familia que se desmoronó"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "but_about_the_end_of_a_relationship_a_family_that_fell_apart",
    "journeyBlueprintId": "but_about_the_end_of_a_relationship_a_family_that_fell_apart"
  },
  {
    "key": "mourning_for_lost_health_chronic_illness_injury",
    "groupKey": "loss_grief_radical_changes",
    "title": {
      "he": "אבל על בריאות שאבדה (חולי כרוני, פציעה)",
      "en": "Mourning for lost health (chronic illness, injury)",
      "es": "Duelo por la pérdida de salud (enfermedad crónica, lesión)"
    },
    "shortDescription": {
      "he": "אבל על בריאות שאבדה (חולי כרוני, פציעה)",
      "en": "Mourning for lost health (chronic illness, injury)",
      "es": "Duelo por la pérdida de salud (enfermedad crónica, lesión)"
    },
    "description": {
      "he": "אבל על בריאות שאבדה (חולי כרוני, פציעה)",
      "en": "Mourning for lost health (chronic illness, injury)",
      "es": "Duelo por la pérdida de salud (enfermedad crónica, lesión)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "mourning_for_lost_health_chronic_illness_injury",
    "journeyBlueprintId": "mourning_for_lost_health_chronic_illness_injury"
  },
  {
    "key": "crossing_the_country_immigration_emotional_refugees",
    "groupKey": "loss_grief_radical_changes",
    "title": {
      "he": "מעבר מדינה / הגירה – פליטות רגשית",
      "en": "Crossing the country / immigration - emotional refugees",
      "es": "Cruzar el país / inmigración - refugiados emocionales"
    },
    "shortDescription": {
      "he": "מעבר מדינה / הגירה – פליטות רגשית",
      "en": "Crossing the country / immigration - emotional refugees",
      "es": "Cruzar el país / inmigración - refugiados emocionales"
    },
    "description": {
      "he": "מעבר מדינה / הגירה – פליטות רגשית",
      "en": "Crossing the country / immigration - emotional refugees",
      "es": "Cruzar el país / inmigración - refugiados emocionales"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "crossing_the_country_immigration_emotional_refugees",
    "journeyBlueprintId": "crossing_the_country_immigration_emotional_refugees"
  },
  {
    "key": "retirement_retirement",
    "groupKey": "loss_grief_radical_changes",
    "title": {
      "he": "פרישה מעבודה / יציאה לפנסיה",
      "en": "Retirement / Retirement",
      "es": "Jubilación / Jubilación"
    },
    "shortDescription": {
      "he": "פרישה מעבודה / יציאה לפנסיה",
      "en": "Retirement / Retirement",
      "es": "Jubilación / Jubilación"
    },
    "description": {
      "he": "פרישה מעבודה / יציאה לפנסיה",
      "en": "Retirement / Retirement",
      "es": "Jubilación / Jubilación"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "retirement_retirement",
    "journeyBlueprintId": "retirement_retirement"
  },
  {
    "key": "empty_nest_the_children_have_left_the_house",
    "groupKey": "loss_grief_radical_changes",
    "title": {
      "he": "“קינון ריק” – הילדים עזבו את הבית",
      "en": "\"Empty nest\" - the children have left the house",
      "es": "\"Nido vacío\": los niños se han ido de casa"
    },
    "shortDescription": {
      "he": "“קינון ריק” – הילדים עזבו את הבית",
      "en": "\"Empty nest\" - the children have left the house",
      "es": "\"Nido vacío\": los niños se han ido de casa"
    },
    "description": {
      "he": "“קינון ריק” – הילדים עזבו את הבית",
      "en": "\"Empty nest\" - the children have left the house",
      "es": "\"Nido vacío\": los niños se han ido de casa"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "empty_nest_the_children_have_left_the_house",
    "journeyBlueprintId": "empty_nest_the_children_have_left_the_house"
  },
  {
    "key": "trauma_from_wars_disasters_accidents",
    "groupKey": "trauma_vulnerability",
    "title": {
      "he": "טראומה ממלחמות / אסונות / תאונות",
      "en": "Trauma from wars / disasters / accidents",
      "es": "Trauma por guerras / desastres / accidentes"
    },
    "shortDescription": {
      "he": "טראומה ממלחמות / אסונות / תאונות",
      "en": "Trauma from wars / disasters / accidents",
      "es": "Trauma por guerras / desastres / accidentes"
    },
    "description": {
      "he": "טראומה ממלחמות / אסונות / תאונות",
      "en": "Trauma from wars / disasters / accidents",
      "es": "Trauma por guerras / desastres / accidentes"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "trauma_from_wars_disasters_accidents",
    "journeyBlueprintId": "trauma_from_wars_disasters_accidents"
  },
  {
    "key": "trauma_after_betrayal_extreme_abandonment",
    "groupKey": "trauma_vulnerability",
    "title": {
      "he": "טראומה אחרי בגידה / נטישה קיצונית",
      "en": "Trauma after betrayal / extreme abandonment",
      "es": "Trauma tras traición/abandono extremo"
    },
    "shortDescription": {
      "he": "טראומה אחרי בגידה / נטישה קיצונית",
      "en": "Trauma after betrayal / extreme abandonment",
      "es": "Trauma tras traición/abandono extremo"
    },
    "description": {
      "he": "טראומה אחרי בגידה / נטישה קיצונית",
      "en": "Trauma after betrayal / extreme abandonment",
      "es": "Trauma tras traición/abandono extremo"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "trauma_after_betrayal_extreme_abandonment",
    "journeyBlueprintId": "trauma_after_betrayal_extreme_abandonment"
  },
  {
    "key": "repeated_emotional_injuries_humiliation_humiliation_shame",
    "groupKey": "trauma_vulnerability",
    "title": {
      "he": "פגיעות רגשיות חוזרות – השפלה, ביזוי, בושה",
      "en": "Repeated emotional injuries - humiliation, humiliation, shame",
      "es": "Lesiones emocionales repetidas: humillación, humillación, vergüenza."
    },
    "shortDescription": {
      "he": "פגיעות רגשיות חוזרות – השפלה, ביזוי, בושה",
      "en": "Repeated emotional injuries - humiliation, humiliation, shame",
      "es": "Lesiones emocionales repetidas: humillación, humillación, vergüenza."
    },
    "description": {
      "he": "פגיעות רגשיות חוזרות – השפלה, ביזוי, בושה",
      "en": "Repeated emotional injuries - humiliation, humiliation, shame",
      "es": "Lesiones emocionales repetidas: humillación, humillación, vergüenza."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "repeated_emotional_injuries_humiliation_humiliation_shame",
    "journeyBlueprintId": "repeated_emotional_injuries_humiliation_humiliation_shame"
  },
  {
    "key": "deep_distrust_in_humans_after_a_difficult_experience",
    "groupKey": "trauma_vulnerability",
    "title": {
      "he": "חוסר אמון עמוק בבני אדם אחרי התנסות קשה",
      "en": "Deep distrust in humans after a difficult experience",
      "es": "Profunda desconfianza en los humanos después de una experiencia difícil"
    },
    "shortDescription": {
      "he": "חוסר אמון עמוק בבני אדם אחרי התנסות קשה",
      "en": "Deep distrust in humans after a difficult experience",
      "es": "Profunda desconfianza en los humanos después de una experiencia difícil"
    },
    "description": {
      "he": "חוסר אמון עמוק בבני אדם אחרי התנסות קשה",
      "en": "Deep distrust in humans after a difficult experience",
      "es": "Profunda desconfianza en los humanos después de una experiencia difícil"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "deep_distrust_in_humans_after_a_difficult_experience",
    "journeyBlueprintId": "deep_distrust_in_humans_after_a_difficult_experience"
  },
  {
    "key": "flashbacks_bad_dreams_chronic_stress",
    "groupKey": "trauma_vulnerability",
    "title": {
      "he": "פלאשבקים, חלומות רעים, מתח כרוני",
      "en": "Flashbacks, bad dreams, chronic stress",
      "es": "Flashbacks, malos sueños, estrés crónico."
    },
    "shortDescription": {
      "he": "פלאשבקים, חלומות רעים, מתח כרוני",
      "en": "Flashbacks, bad dreams, chronic stress",
      "es": "Flashbacks, malos sueños, estrés crónico."
    },
    "description": {
      "he": "פלאשבקים, חלומות רעים, מתח כרוני",
      "en": "Flashbacks, bad dreams, chronic stress",
      "es": "Flashbacks, malos sueños, estrés crónico."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "flashbacks_bad_dreams_chronic_stress",
    "journeyBlueprintId": "flashbacks_bad_dreams_chronic_stress"
  },
  {
    "key": "living_with_chronic_pain",
    "groupKey": "health_body_self_image",
    "title": {
      "he": "חיים עם כאב כרוני",
      "en": "Living with chronic pain",
      "es": "Vivir con dolor crónico"
    },
    "shortDescription": {
      "he": "חיים עם כאב כרוני",
      "en": "Living with chronic pain",
      "es": "Vivir con dolor crónico"
    },
    "description": {
      "he": "חיים עם כאב כרוני",
      "en": "Living with chronic pain",
      "es": "Vivir con dolor crónico"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "living_with_chronic_pain",
    "journeyBlueprintId": "living_with_chronic_pain"
  },
  {
    "key": "long_term_illness_my_own_a_family_member_s",
    "groupKey": "health_body_self_image",
    "title": {
      "he": "מחלה ארוכת טווח (שלי / של בן משפחה)",
      "en": "Long-term illness (my own / a family member's)",
      "es": "Enfermedad de larga duración (propia/de un familiar)"
    },
    "shortDescription": {
      "he": "מחלה ארוכת טווח (שלי / של בן משפחה)",
      "en": "Long-term illness (my own / a family member's)",
      "es": "Enfermedad de larga duración (propia/de un familiar)"
    },
    "description": {
      "he": "מחלה ארוכת טווח (שלי / של בן משפחה)",
      "en": "Long-term illness (my own / a family member's)",
      "es": "Enfermedad de larga duración (propia/de un familiar)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "long_term_illness_my_own_a_family_member_s",
    "journeyBlueprintId": "long_term_illness_my_own_a_family_member_s"
  },
  {
    "key": "health_anxiety_every_symptom_a_movie_in_the_head",
    "groupKey": "health_body_self_image",
    "title": {
      "he": "חרדת בריאות (“כל סימפטום – סרט בראש”)",
      "en": "Health anxiety (\"every symptom - a movie in the head\")",
      "es": "Ansiedad por la salud (\"cada síntoma es una película en la cabeza\")"
    },
    "shortDescription": {
      "he": "חרדת בריאות (“כל סימפטום – סרט בראש”)",
      "en": "Health anxiety (\"every symptom - a movie in the head\")",
      "es": "Ansiedad por la salud (\"cada síntoma es una película en la cabeza\")"
    },
    "description": {
      "he": "חרדת בריאות (“כל סימפטום – סרט בראש”)",
      "en": "Health anxiety (\"every symptom - a movie in the head\")",
      "es": "Ansiedad por la salud (\"cada síntoma es una película en la cabeza\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "health_anxiety_every_symptom_a_movie_in_the_head",
    "journeyBlueprintId": "health_anxiety_every_symptom_a_movie_in_the_head"
  },
  {
    "key": "body_shame_weight_appearance",
    "groupKey": "health_body_self_image",
    "title": {
      "he": "בושה בגוף / משקל / מראה",
      "en": "Body shame / weight / appearance",
      "es": "Vergüenza corporal / peso / apariencia"
    },
    "shortDescription": {
      "he": "בושה בגוף / משקל / מראה",
      "en": "Body shame / weight / appearance",
      "es": "Vergüenza corporal / peso / apariencia"
    },
    "description": {
      "he": "בושה בגוף / משקל / מראה",
      "en": "Body shame / weight / appearance",
      "es": "Vergüenza corporal / peso / apariencia"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "body_shame_weight_appearance",
    "journeyBlueprintId": "body_shame_weight_appearance"
  },
  {
    "key": "aging_getting_the_wrinkles_the_body_the_abilities",
    "groupKey": "health_body_self_image",
    "title": {
      "he": "הזדקנות – קבלת הקמטים, הגוף, היכולות",
      "en": "Aging - getting the wrinkles, the body, the abilities",
      "es": "Envejecimiento: las arrugas, el cuerpo, las capacidades."
    },
    "shortDescription": {
      "he": "הזדקנות – קבלת הקמטים, הגוף, היכולות",
      "en": "Aging - getting the wrinkles, the body, the abilities",
      "es": "Envejecimiento: las arrugas, el cuerpo, las capacidades."
    },
    "description": {
      "he": "הזדקנות – קבלת הקמטים, הגוף, היכולות",
      "en": "Aging - getting the wrinkles, the body, the abilities",
      "es": "Envejecimiento: las arrugas, el cuerpo, las capacidades."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "aging_getting_the_wrinkles_the_body_the_abilities",
    "journeyBlueprintId": "aging_getting_the_wrinkles_the_body_the_abilities"
  },
  {
    "key": "emotional_eating",
    "groupKey": "harmful_habits_light_addictions",
    "title": {
      "he": "אכילה רגשית",
      "en": "emotional eating",
      "es": "comer emocional"
    },
    "shortDescription": {
      "he": "אכילה רגשית",
      "en": "emotional eating",
      "es": "comer emocional"
    },
    "description": {
      "he": "אכילה רגשית",
      "en": "emotional eating",
      "es": "comer emocional"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "emotional_eating",
    "journeyBlueprintId": "emotional_eating"
  },
  {
    "key": "escape_to_screens_phone_social_networks",
    "groupKey": "harmful_habits_light_addictions",
    "title": {
      "he": "בריחה למסכים / טלפון / רשתות חברתיות",
      "en": "Escape to screens / phone / social networks",
      "es": "Escapar a las pantallas/teléfono/redes sociales"
    },
    "shortDescription": {
      "he": "בריחה למסכים / טלפון / רשתות חברתיות",
      "en": "Escape to screens / phone / social networks",
      "es": "Escapar a las pantallas/teléfono/redes sociales"
    },
    "description": {
      "he": "בריחה למסכים / טלפון / רשתות חברתיות",
      "en": "Escape to screens / phone / social networks",
      "es": "Escapar a las pantallas/teléfono/redes sociales"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "escape_to_screens_phone_social_networks",
    "journeyBlueprintId": "escape_to_screens_phone_social_networks"
  },
  {
    "key": "work_as_emotional_compensation_workaholism",
    "groupKey": "harmful_habits_light_addictions",
    "title": {
      "he": "עבודה כפיצוי רגשי (Workaholism)",
      "en": "Work as emotional compensation (Workaholism)",
      "es": "El trabajo como compensación emocional (adicción al trabajo)"
    },
    "shortDescription": {
      "he": "עבודה כפיצוי רגשי (Workaholism)",
      "en": "Work as emotional compensation (Workaholism)",
      "es": "El trabajo como compensación emocional (adicción al trabajo)"
    },
    "description": {
      "he": "עבודה כפיצוי רגשי (Workaholism)",
      "en": "Work as emotional compensation (Workaholism)",
      "es": "El trabajo como compensación emocional (adicción al trabajo)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "work_as_emotional_compensation_workaholism",
    "journeyBlueprintId": "work_as_emotional_compensation_workaholism"
  },
  {
    "key": "escaping_to_the_stochs_unattached_sex",
    "groupKey": "harmful_habits_light_addictions",
    "title": {
      "he": "בריחה לסטוצ’ים / סקס לא מחובר",
      "en": "Escaping to the Stochs / unattached sex",
      "es": "Escapar a los Stochs / sexo sin ataduras"
    },
    "shortDescription": {
      "he": "בריחה לסטוצ’ים / סקס לא מחובר",
      "en": "Escaping to the Stochs / unattached sex",
      "es": "Escapar a los Stochs / sexo sin ataduras"
    },
    "description": {
      "he": "בריחה לסטוצ’ים / סקס לא מחובר",
      "en": "Escaping to the Stochs / unattached sex",
      "es": "Escapar a los Stochs / sexo sin ataduras"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "escaping_to_the_stochs_unattached_sex",
    "journeyBlueprintId": "escaping_to_the_stochs_unattached_sex"
  },
  {
    "key": "compulsive_buying_wasting_to_not_feel",
    "groupKey": "harmful_habits_light_addictions",
    "title": {
      "he": "קנייה כפייתית / בזבוזים כדי לא להרגיש",
      "en": "Compulsive buying/wasting to not feel",
      "es": "Compra compulsiva/desperdicio para no sentir"
    },
    "shortDescription": {
      "he": "קנייה כפייתית / בזבוזים כדי לא להרגיש",
      "en": "Compulsive buying/wasting to not feel",
      "es": "Compra compulsiva/desperdicio para no sentir"
    },
    "description": {
      "he": "קנייה כפייתית / בזבוזים כדי לא להרגיש",
      "en": "Compulsive buying/wasting to not feel",
      "es": "Compra compulsiva/desperdicio para no sentir"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "compulsive_buying_wasting_to_not_feel",
    "journeyBlueprintId": "compulsive_buying_wasting_to_not_feel"
  },
  {
    "key": "crisis_of_faith_anger_at_god_at_fate",
    "groupKey": "spirituality_faith_meaning",
    "title": {
      "he": "משבר אמונה / כעס על אלוהים / על גורל",
      "en": "Crisis of faith / anger at God / at fate",
      "es": "Crisis de fe / ira contra Dios / contra el destino"
    },
    "shortDescription": {
      "he": "משבר אמונה / כעס על אלוהים / על גורל",
      "en": "Crisis of faith / anger at God / at fate",
      "es": "Crisis de fe / ira contra Dios / contra el destino"
    },
    "description": {
      "he": "משבר אמונה / כעס על אלוהים / על גורל",
      "en": "Crisis of faith / anger at God / at fate",
      "es": "Crisis de fe / ira contra Dios / contra el destino"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "crisis_of_faith_anger_at_god_at_fate",
    "journeyBlueprintId": "crisis_of_faith_anger_at_god_at_fate"
  },
  {
    "key": "religious_guilt_not_good_enough_in_the_eyes_of_heaven",
    "groupKey": "spirituality_faith_meaning",
    "title": {
      "he": "אשמה דתית (“לא מספיק טוב/ה בעיני שמיים”)",
      "en": "Religious guilt (\"not good enough in the eyes of heaven\")",
      "es": "Culpa religiosa (\"no es lo suficientemente bueno a los ojos del cielo\")"
    },
    "shortDescription": {
      "he": "אשמה דתית (“לא מספיק טוב/ה בעיני שמיים”)",
      "en": "Religious guilt (\"not good enough in the eyes of heaven\")",
      "es": "Culpa religiosa (\"no es lo suficientemente bueno a los ojos del cielo\")"
    },
    "description": {
      "he": "אשמה דתית (“לא מספיק טוב/ה בעיני שמיים”)",
      "en": "Religious guilt (\"not good enough in the eyes of heaven\")",
      "es": "Culpa religiosa (\"no es lo suficientemente bueno a los ojos del cielo\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "religious_guilt_not_good_enough_in_the_eyes_of_heaven",
    "journeyBlueprintId": "religious_guilt_not_good_enough_in_the_eyes_of_heaven"
  },
  {
    "key": "i_ve_lost_my_spiritual_connection_feeling",
    "groupKey": "spirituality_faith_meaning",
    "title": {
      "he": "תחושת “איבדתי את החיבור הרוחני שלי”",
      "en": "\"I've lost my spiritual connection\" feeling",
      "es": "Sentimiento de \"he perdido mi conexión espiritual\""
    },
    "shortDescription": {
      "he": "תחושת “איבדתי את החיבור הרוחני שלי”",
      "en": "\"I've lost my spiritual connection\" feeling",
      "es": "Sentimiento de \"he perdido mi conexión espiritual\""
    },
    "description": {
      "he": "תחושת “איבדתי את החיבור הרוחני שלי”",
      "en": "\"I've lost my spiritual connection\" feeling",
      "es": "Sentimiento de \"he perdido mi conexión espiritual\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "i_ve_lost_my_spiritual_connection_feeling",
    "journeyBlueprintId": "i_ve_lost_my_spiritual_connection_feeling"
  },
  {
    "key": "search_for_meaning_why_am_i_even_here",
    "groupKey": "spirituality_faith_meaning",
    "title": {
      "he": "חיפוש משמעות (“למה בכלל אני פה?”)",
      "en": "Search for meaning (\"Why am I even here?\")",
      "es": "Búsqueda de significado (\"¿Por qué estoy aquí?\")"
    },
    "shortDescription": {
      "he": "חיפוש משמעות (“למה בכלל אני פה?”)",
      "en": "Search for meaning (\"Why am I even here?\")",
      "es": "Búsqueda de significado (\"¿Por qué estoy aquí?\")"
    },
    "description": {
      "he": "חיפוש משמעות (“למה בכלל אני פה?”)",
      "en": "Search for meaning (\"Why am I even here?\")",
      "es": "Búsqueda de significado (\"¿Por qué estoy aquí?\")"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "search_for_meaning_why_am_i_even_here",
    "journeyBlueprintId": "search_for_meaning_why_am_i_even_here"
  },
  {
    "key": "conflict_between_personal_values_and_religious_family_framework",
    "groupKey": "spirituality_faith_meaning",
    "title": {
      "he": "קונפליקט בין ערכים אישיים לבין מסגרת דתית / משפחתית",
      "en": "Conflict between personal values ​​and religious / family framework",
      "es": "Conflicto entre valores personales y marco religioso/familiar"
    },
    "shortDescription": {
      "he": "קונפליקט בין ערכים אישיים לבין מסגרת דתית / משפחתית",
      "en": "Conflict between personal values ​​and religious / family framework",
      "es": "Conflicto entre valores personales y marco religioso/familiar"
    },
    "description": {
      "he": "קונפליקט בין ערכים אישיים לבין מסגרת דתית / משפחתית",
      "en": "Conflict between personal values ​​and religious / family framework",
      "es": "Conflicto entre valores personales y marco religioso/familiar"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "conflict_between_personal_values_and_religious_family_framework",
    "journeyBlueprintId": "conflict_between_personal_values_and_religious_family_framework"
  },
  {
    "key": "i_don_t_know_who_i_am_anymore",
    "groupKey": "inner_identity_self_confusion",
    "title": {
      "he": "“אני לא יודע מי אני כבר”",
      "en": "\"I don't know who I am anymore\"",
      "es": "\"Ya no sé quién soy\""
    },
    "shortDescription": {
      "he": "“אני לא יודע מי אני כבר”",
      "en": "\"I don't know who I am anymore\"",
      "es": "\"Ya no sé quién soy\""
    },
    "description": {
      "he": "“אני לא יודע מי אני כבר”",
      "en": "\"I don't know who I am anymore\"",
      "es": "\"Ya no sé quién soy\""
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "i_don_t_know_who_i_am_anymore",
    "journeyBlueprintId": "i_don_t_know_who_i_am_anymore"
  },
  {
    "key": "collapse_of_old_roles_parent_spouse_successful",
    "groupKey": "inner_identity_self_confusion",
    "title": {
      "he": "קריסה של תפקידים ישנים (הורה, בן זוג, מצליחן)",
      "en": "Collapse of old roles (parent, spouse, successful)",
      "es": "Colapso de viejos roles (padre, cónyuge, exitoso)"
    },
    "shortDescription": {
      "he": "קריסה של תפקידים ישנים (הורה, בן זוג, מצליחן)",
      "en": "Collapse of old roles (parent, spouse, successful)",
      "es": "Colapso de viejos roles (padre, cónyuge, exitoso)"
    },
    "description": {
      "he": "קריסה של תפקידים ישנים (הורה, בן זוג, מצליחן)",
      "en": "Collapse of old roles (parent, spouse, successful)",
      "es": "Colapso de viejos roles (padre, cónyuge, exitoso)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "collapse_of_old_roles_parent_spouse_successful",
    "journeyBlueprintId": "collapse_of_old_roles_parent_spouse_successful"
  },
  {
    "key": "a_conflict_between_who_i_really_am_and_what_society_expects",
    "groupKey": "inner_identity_self_confusion",
    "title": {
      "he": "קונפליקט בין “מי שאני באמת” לבין מה שהחברה מצפה",
      "en": "A conflict between \"who I really am\" and what society expects",
      "es": "Un conflicto entre \"quién soy realmente\" y lo que espera la sociedad"
    },
    "shortDescription": {
      "he": "קונפליקט בין “מי שאני באמת” לבין מה שהחברה מצפה",
      "en": "A conflict between \"who I really am\" and what society expects",
      "es": "Un conflicto entre \"quién soy realmente\" y lo que espera la sociedad"
    },
    "description": {
      "he": "קונפליקט בין “מי שאני באמת” לבין מה שהחברה מצפה",
      "en": "A conflict between \"who I really am\" and what society expects",
      "es": "Un conflicto entre \"quién soy realmente\" y lo que espera la sociedad"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "a_conflict_between_who_i_really_am_and_what_society_expects",
    "journeyBlueprintId": "a_conflict_between_who_i_really_am_and_what_society_expects"
  },
  {
    "key": "confusion_about_the_choices_in_life_relationship_career_place_of_residence",
    "groupKey": "inner_identity_self_confusion",
    "title": {
      "he": "בלבול לגבי הבחירות בחיים – זוגיות, קריירה, מקום מגורים",
      "en": "Confusion about the choices in life - relationship, career, place of residence",
      "es": "Confusión sobre las opciones en la vida: relación, carrera, lugar de residencia."
    },
    "shortDescription": {
      "he": "בלבול לגבי הבחירות בחיים – זוגיות, קריירה, מקום מגורים",
      "en": "Confusion about the choices in life - relationship, career, place of residence",
      "es": "Confusión sobre las opciones en la vida: relación, carrera, lugar de residencia."
    },
    "description": {
      "he": "בלבול לגבי הבחירות בחיים – זוגיות, קריירה, מקום מגורים",
      "en": "Confusion about the choices in life - relationship, career, place of residence",
      "es": "Confusión sobre las opciones en la vida: relación, carrera, lugar de residencia."
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "confusion_about_the_choices_in_life_relationship_career_place_of_residence",
    "journeyBlueprintId": "confusion_about_the_choices_in_life_relationship_career_place_of_residence"
  },
  {
    "key": "difficulty_accepting_certain_parts_of_myself_sensitivity_weakness_inner_darkness",
    "groupKey": "inner_identity_self_confusion",
    "title": {
      "he": "קושי לקבל חלקים מסוימים בעצמי (רגישות, חולשה, “חושך” פנימי)",
      "en": "Difficulty accepting certain parts of myself (sensitivity, weakness, inner \"darkness\")",
      "es": "Dificultad para aceptar ciertas partes de mí mismo (sensibilidad, debilidad, \"oscuridad\" interior)"
    },
    "shortDescription": {
      "he": "קושי לקבל חלקים מסוימים בעצמי (רגישות, חולשה, “חושך” פנימי)",
      "en": "Difficulty accepting certain parts of myself (sensitivity, weakness, inner \"darkness\")",
      "es": "Dificultad para aceptar ciertas partes de mí mismo (sensibilidad, debilidad, \"oscuridad\" interior)"
    },
    "description": {
      "he": "קושי לקבל חלקים מסוימים בעצמי (רגישות, חולשה, “חושך” פנימי)",
      "en": "Difficulty accepting certain parts of myself (sensitivity, weakness, inner \"darkness\")",
      "es": "Dificultad para aceptar ciertas partes de mí mismo (sensibilidad, debilidad, \"oscuridad\" interior)"
    },
    "defaultDays": 14,
    "defaultJourneyBlueprintId": "difficulty_accepting_certain_parts_of_myself_sensitivity_weakness_inner_darkness",
    "journeyBlueprintId": "difficulty_accepting_certain_parts_of_myself_sensitivity_weakness_inner_darkness"
  }
];

export function getProblemByKey(problemKey) {
  if (!problemKey) return null;
  return PROBLEM_LIST.find((p) => p.key === problemKey) || null;
}

function extractDurationFromText(text) {
  if (!text) return null;
  const match = String(text).match(/(?:—|-)\s*(\d+)\s*(?:ימים|days?|d[ií]as?)\s*$/i);
  if (!match) return null;
  const n = Number(match[1]);
  return Number.isFinite(n) ? n : null;
}

function stripDurationSuffix(text) {
  if (!text) return "";
  return String(text)
    .replace(/\s*(?:—|-)\s*\d+\s*(?:ימים|days?|d[ií]as?)\s*$/i, "")
    .trim();
}

function dayUnit(days, lang) {
  const safeLang = (lang || "he").toLowerCase();
  if (safeLang === "en") return days === 1 ? "day" : "days";
  if (safeLang === "es") return days === 1 ? "día" : "días";
  return days === 1 ? "יום" : "ימים";
}

function getDurationDays(problem, rawText) {
  return (
    extractDurationFromText(rawText) ||
    problem?.durationDays ||
    problem?.totalDays ||
    problem?.defaultDays ||
    null
  );
}

function withLocalizedDuration(text, days, lang) {
  if (!text) return "";
  if (!days) return text;
  return `${text} — ${days} ${dayUnit(days, lang)}`;
}

export function getProblemTitleForLang(problemOrKey, lang = "he", options = {}) {
  const problem = typeof problemOrKey === "string" ? getProblemByKey(problemOrKey) : problemOrKey;
  if (!problem) return "";
  const safeLang = (lang || "he").toLowerCase();
  const includeDuration = options.includeDuration !== false;
  const raw = (problem.title && (problem.title[safeLang] || problem.title.he)) || problem.key;
  const clean = stripDurationSuffix(raw);
  if (!includeDuration) return clean;
  return withLocalizedDuration(clean, getDurationDays(problem, raw), safeLang);
}

export function getProblemShortDescriptionForLang(problemOrKey, lang = "he") {
  const problem = typeof problemOrKey === "string" ? getProblemByKey(problemOrKey) : problemOrKey;
  if (!problem) return "";
  const safeLang = (lang || "he").toLowerCase();
  const raw =
    (problem.shortDescription && (problem.shortDescription[safeLang] || problem.shortDescription.he)) ||
    (problem.description && (problem.description[safeLang] || problem.description.he)) ||
    "";
  const clean = stripDurationSuffix(raw);
  return withLocalizedDuration(clean, getDurationDays(problem, raw), safeLang);
}

export function getProblemsByGroup(groupKey) {
  if (!groupKey) return [];
  return PROBLEM_LIST.filter((p) => p.groupKey === groupKey);
}

export function getGroupsForLang(lang = "he") {
  const safeLang = (lang || "he").toLowerCase();
  return PROBLEM_GROUPS.filter((group) => group.labels?.[safeLang] || group.labels?.he);
}

export function hasProblemsForLang(lang = "he") {
  const safeLang = (lang || "he").toLowerCase();
  return PROBLEM_LIST.some((p) => p.title && (p.title[safeLang] || p.title.he));
}

export const JOURNEY_PROBLEMS = PROBLEM_LIST;
export default JOURNEY_PROBLEMS;
